import React, { useState } from "react";

// API endpoints (server-side PHP in /public/php)
const PHP_ROOT = "/php"; // adjust if your PHP files are in a different path
const EMPLOYEE_PORTAL = PHP_ROOT + "/employee_portal.php";
const ADMIN_PORTAL = PHP_ROOT + "/admin_portal.php";
const REGISTER_PIN = PHP_ROOT + "/register_pin.php";
const EMPLOYEES_API = PHP_ROOT + "/employees.php";
const SEND_NOTIFICATION = PHP_ROOT + "/send_registration_notification.php";

export default function Personalistika() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  // Admin edit state
  const [editingPin, setEditingPin] = useState(null);
  const [editData, setEditData] = useState({});
  const [editSaving, setEditSaving] = useState(false);
  const [editMessage, setEditMessage] = useState("");
  const [docsPin, setDocsPin] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [docsLoading, setDocsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState('all'); // all | missing_sp | missing_zp | missing_school | missing_deduction | missing_invalidity | missing_any | overdue_sp | overdue_zp | only_brigade | only_pensioner | only_invalid | only_issues
  const [includeOtherObl, setIncludeOtherObl] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [showAddEmployee, setShowAddEmployee] = useState(false); // Show add employee form in admin zone
  const [showNewEmployeeForm, setShowNewEmployeeForm] = useState(false); // Show new employee form in admin zone

  // Lightweight UI styles for admin zone
  const ui = {
    card: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, boxShadow: '0 2px 12px rgba(15,23,42,0.06)', padding: 16 },
    tableWrap: { overflowY: 'auto', borderRadius: 10, border: '1px solid #e5e7eb', maxHeight: 450, background: '#fff' },
    table: { width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: 11 },
    th: { textAlign: 'left', padding: '6px 8px', background: '#f6f8fa', borderBottom: '1px solid #e5e7eb', fontSize: 10, color: '#0f172a', letterSpacing: 0.2, whiteSpace: 'nowrap', position: 'sticky', top: 0, zIndex: 10 },
    td: { padding: '6px 8px', borderBottom: '1px solid #f1f5f9', fontSize: 11, whiteSpace: 'nowrap' },
    btn: { padding: '4px 8px', borderRadius: 6, border: '1px solid #2563eb', background: '#2563eb', color: '#fff', cursor: 'pointer', fontSize: 10 },
    btnGhost: { padding: '4px 8px', borderRadius: 6, border: '1px solid #e5e7eb', background: '#fff', color: '#0f172a', cursor: 'pointer', fontSize: 10 },
    badge: { display: 'inline-block', padding: '2px 6px', background: '#eef2ff', color: '#3730a3', borderRadius: 999, fontSize: 10 }
  };
  const [pinInput, setPinInput] = useState("");
  const [pinError, setPinError] = useState("");
  const [adminUsername, setAdminUsername] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [adminError, setAdminError] = useState("");
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [showAdminPassword, setShowAdminPassword] = useState(false);
  const [showAdminRegister, setShowAdminRegister] = useState(false);
  const [loginPanelOpen, setLoginPanelOpen] = useState(false);
  const [regAdminUsername, setRegAdminUsername] = useState("");
  const [regAdminEmail, setRegAdminEmail] = useState("");
  const [regAdminPassword, setRegAdminPassword] = useState("");
  const [regAdminPassword2, setRegAdminPassword2] = useState("");
  const [showRegPassword, setShowRegPassword] = useState(false);
  const [showRegPassword2, setShowRegPassword2] = useState(false);
  const [regAdminError, setRegAdminError] = useState("");
  const [regAdminSuccess, setRegAdminSuccess] = useState("");
  const [employees, setEmployees] = useState([]);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [employeePin, setEmployeePin] = useState(''); // Store PIN for logged-in employee
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [saving, setSaving] = useState(false);
  const [childrenCount, setChildrenCount] = useState(0);
  const [hasHealthIssues, setHasHealthIssues] = useState(false);
  const [insuranceOther, setInsuranceOther] = useState(false);
  const [stateOther, setStateOther] = useState(false);
  const [contractTypeValue, setContractTypeValue] = useState('');
  const [isDohoda, setIsDohoda] = useState(false); // Track if contract type is "dohoda"
  const [trialRequired, setTrialRequired] = useState(false);
  const [isStudentBrigade, setIsStudentBrigade] = useState(false);
  const [errors, setErrors] = useState({});
  const formRef = React.useRef(null);

  // Client-side validation helpers
  const requiredFields = [
    'email', 'firstName', 'lastName', 'birthDate', 'rodne_cislo', 'birth_place', 'nationality',
    'state_citizenship', 'id_card', 'street_name', 'cislo_domu', 'zip', 'city', 'phone',
    'insurance', 'contractType', 'wage_type',
    'company', 'declaration_truth', 'consent_gdpr', 'pin'
    // is_student, is_pensioner, is_invalid_pensioner, is_registered_unemployment are optional checkboxes
    // Optional fields (can be filled later by admin): marital_status, position, startDate, dohodnuty_uvazok, contract_duration_type, children_count, wage_brutto
  ];

  function validateField(name, value) {
    const e = {};
    if (requiredFields.includes(name)) {
      if (value === undefined || value === null || String(value).trim() === '') {
        e[name] = 'Toto pole je povinné';
        return e;
      }
    }
    if (name === 'email' && value) {
      const ok = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
      if (!ok) e[name] = 'Neplatný e‑mail';
    }
    if (name === 'bank_iban' && value && String(value).trim() !== '') {
      const iban = String(value).replace(/\s+/g, '').toUpperCase();
      if (!/^[A-Z0-9]{15,34}$/.test(iban)) e[name] = 'Neplatný IBAN';
    }
    if (name === 'phone' && value) {
      const p = String(value).replace(/[^0-9+]/g, '');
      if (p.length < 6) e[name] = 'Príliš krátke telefónne číslo';
    }
    return e;
  }

  // Helper to update errors - removes error if validation passes
  function handleFieldBlur(name, value) {
    setErrors(prev => {
      const newErrors = { ...prev };
      const fieldError = validateField(name, value);
      if (Object.keys(fieldError).length === 0) {
        // No error - remove from errors if exists
        delete newErrors[name];
      } else {
        // Has error - add/update it
        Object.assign(newErrors, fieldError);
      }
      return newErrors;
    });
  }

  function validateAll(obj, skipEmail = false) {
    const errs = {};
    requiredFields.forEach((f) => {
      // Skip email validation if skipEmail is true (admin mode)
      if (f === 'email' && skipEmail) return;
      if (!obj.hasOwnProperty(f) || String(obj[f]).trim() === '') {
        errs[f] = 'Toto pole je povinné';
      }
    });
    // Dynamic required fields
    if (obj.state_citizenship === 'other') {
      if (!obj.state_citizenship_other || String(obj.state_citizenship_other).trim() === '') {
        errs.state_citizenship_other = 'Uveďte štátnu príslušnosť';
      }
    }
    if (obj.insurance === 'other') {
      if (!obj.insurance_other || String(obj.insurance_other).trim() === '') {
        errs.insurance_other = 'Uveďte poisťovňu';
      }
    }
    if (obj.contractType === 'skraty_uvazok') {
      if (!obj.part_time_hours_per_day || String(obj.part_time_hours_per_day).trim() === '') {
        errs.part_time_hours_per_day = 'Uveďte počet hodín za deň';
      }
    }
    if (obj.has_health_issues === 'yes') {
      if (!obj.health_notes || String(obj.health_notes).trim() === '') {
        errs.health_notes = 'Uveďte zdravotné obmedzenia / alergie';
      }
    }
    // Numeric sanity checks
    if (obj.children_count !== undefined && String(obj.children_count).trim() !== '') {
      const cc = Number(obj.children_count);
      if (!Number.isFinite(cc) || cc < 0) errs.children_count = 'Neplatný počet detí';
    }
    if (obj.wage_brutto !== undefined && String(obj.wage_brutto).trim() !== '') {
      const wb = Number(obj.wage_brutto);
      if (!Number.isFinite(wb) || wb <= 0) errs.wage_brutto = 'Zadajte kladnú sumu';
    }
    // email
    if (obj.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(obj.email)) errs.email = 'Neplatný e‑mail';
    if (obj.bank_iban && String(obj.bank_iban).trim() !== '') {
      const iban = String(obj.bank_iban).replace(/\s+/g, '').toUpperCase();
      if (!/^[A-Z0-9]{15,34}$/.test(iban)) errs.bank_iban = 'Neplatný IBAN';
    }
    if (obj.phone) {
      const p = String(obj.phone).replace(/[^0-9+]/g, '');
      if (p.length < 6) errs.phone = 'Príliš krátke telefónne číslo';
    }
    return { valid: Object.keys(errs).length === 0, errors: errs };
  }

  // Prihlásenie cez PIN (zamestnanec)
  const handlePinLogin = async (e) => {
    e.preventDefault();
    setPinError("");
    try {
      // Regular employee login
      const res = await fetch(EMPLOYEE_PORTAL + `?action=login&pin=${encodeURIComponent(pinInput)}`);
      if (!res.ok) throw new Error('Nesprávny PIN');
      const json = await res.json();
      if (json.success && json.employee) {
        setIsAuthenticated(true);
        setIsAdmin(false);
        setCurrentEmployee(json.employee);
        setEmployeePin(pinInput); // Save PIN for document upload
      } else {
        throw new Error(json.error || 'Nesprávna odpoveď zo servera');
      }
    } catch (err) {
      setPinError(err.message || "Chyba pripojenia k serveru");
    }
  };

  // Admin prihlásenie (username + heslo)
  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setAdminError("");
    try {
      const res = await fetch(ADMIN_PORTAL + '?action=login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: adminUsername, password: adminPassword })
      });

      const text = await res.text();
      let data = null;
      try { data = JSON.parse(text); } catch (e) {
        throw new Error('Server error: ' + (text.slice(0, 200) || res.statusText));
      }

      if (!res.ok) throw new Error(data.error || 'Nesprávne prihlasovacie údaje');

      setIsAuthenticated(true);
      setIsAdmin(true);
      setCurrentEmployee(null);
      setEmployees(Array.isArray(data.employees) ? data.employees : []);
      setAdminUsername("");
      setAdminPassword("");
    } catch (err) {
      setAdminError(err.message || "Chyba pripojenia k serveru");
    }
  };

  // Admin registrácia
  const handleAdminRegister = async (e) => {
    e.preventDefault();
    setRegAdminError("");
    setRegAdminSuccess("");
    if (!regAdminUsername || !regAdminPassword) {
      setRegAdminError("Používateľské meno a heslo sú povinné");
      return;
    }
    if (regAdminPassword !== regAdminPassword2) {
      setRegAdminError("Heslá sa nezhodujú");
      return;
    }
    if (regAdminPassword.length < 8 || !/[A-Z]/.test(regAdminPassword) || !/[a-z]/.test(regAdminPassword) || !/\d/.test(regAdminPassword)) {
      setRegAdminError("Heslo musí mať aspoň 8 znakov a obsahovať veľké písmeno, malé písmeno a číslo");
      return;
    }
    try {
      const res = await fetch(ADMIN_PORTAL + '?action=register_admin', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: regAdminUsername, password: regAdminPassword, email: regAdminEmail || undefined })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        throw new Error((data && data.error) || "Registrácia zlyhala");
      }
      setRegAdminSuccess("Admin účet vytvorený. Môžete sa prihlásiť.");
      setTimeout(() => {
        setShowAdminRegister(false);
        setAdminUsername(regAdminUsername);
        setRegAdminUsername("");
        setRegAdminEmail("");
        setRegAdminPassword("");
        setRegAdminPassword2("");
      }, 1500);
    } catch (err) {
      setRegAdminError(err.message || "Registrácia zlyhala");
    }
  };

  // Načítanie všetkých zamestnancov (len pre admina)
  const fetchEmployees = async () => {
    try {
      const res = await fetch(ADMIN_PORTAL + '?action=list_employees');
      const text = await res.text();
      let data = null;
      try { data = JSON.parse(text); } catch (e) { throw new Error('Server returned non-JSON: ' + (text.slice(0, 200) || res.statusText)); }
      if (!res.ok) throw new Error(data.error || 'Chyba pri načítaní zamestnancov');
      setEmployees(Array.isArray(data) ? data : []);
      // if currently editing, keep editor data in sync
      if (editingPin) {
        const refreshed = (Array.isArray(data) ? data : []).find(e => String(e.pin) === String(editingPin));
        if (refreshed) setEditData(refreshed);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const openAdminEdit = (emp) => {
    setEditingPin(emp.pin);
    // ensure obligations structure exists for editor convenience
    const baseObl = emp.obligations && typeof emp.obligations === 'object' ? emp.obligations : {};
    setEditData({ ...emp, obligations: baseObl });
    setEditMessage("");
    setDirty(false);
  };

  const handleAdminEditChange = (field, value) => {
    setEditData(prev => ({ ...prev, [field]: value }));
    setDirty(true);
  };

  const handleAdminSaveEdit = async (closeAfterSave = false) => {
    if (!editingPin) return;
    setEditSaving(true);
    setEditMessage("");
    const payload = { ...editData };
    delete payload.pin;
    try {
      const res = await fetch(ADMIN_PORTAL + '?action=update_employee', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin: editingPin, data: payload })
      });
      const txt = await res.text();
      let data = null;
      try { data = JSON.parse(txt); } catch (e) { data = null; }
      if (!res.ok) throw new Error((data && data.error) || 'Uloženie zlyhalo');
      setEditMessage('Zmeny uložené');
      setDirty(false);
      await fetchEmployees();

      // Close editor if requested (from Ctrl+Enter)
      if (closeAfterSave) {
        setTimeout(() => {
          setEditingPin(null);
          setEditData({});
          setEditMessage('');
          setDirty(false);
        }, 500); // Brief delay to show success message
      }
    } catch (e) {
      setEditMessage(e.message || 'Uloženie zlyhalo');
    } finally {
      setEditSaving(false);
    }
  };

  const loadDocuments = async (pin) => {
    setDocsLoading(true);
    setDocsPin(pin);
    try {
      const res = await fetch(ADMIN_PORTAL + '?action=list_documents&pin=' + encodeURIComponent(pin));
      const text = await res.text();
      let data = null; try { data = JSON.parse(text); } catch (e) { throw new Error('Server vrátil neplatné dáta'); }
      if (!res.ok) throw new Error(data.error || 'Chyba pri načítaní dokumentov');
      setDocuments(Array.isArray(data.documents) ? data.documents : []);
    } catch (e) {
      setDocuments([]);
      console.error(e);
    } finally {
      setDocsLoading(false);
    }
  };

  const handleCloseEditor = () => {
    if (dirty && !window.confirm('Máte neuložené zmeny. Zatvoriť bez uloženia?')) return;
    setEditingPin(null); setEditData({}); setEditMessage(''); setDirty(false);
  };

  // Print employee card with all details and obligations
  const printEmployeeCard = (emp) => {
    const obligations = emp.obligations || {};
    const yn = (v) => (v === '1' || v === 1 || v === true || String(v).toLowerCase() === 'yes') ? 'Áno' : 'Nie';
    const isBrigade = String(emp.contractType || '').toLowerCase().includes('brig');
    const isPensioner = (emp.is_pensioner === '1' || emp.is_pensioner === 1 || emp.is_pensioner === true || String(emp.is_pensioner).toLowerCase() === 'yes');
    const isInvalid = (emp.is_invalid_pensioner === '1' || emp.is_invalid_pensioner === 1 || emp.is_invalid_pensioner === true || String(emp.is_invalid_pensioner).toLowerCase() === 'yes');

    const obligationItems = [
      { key: 'work_start', label: 'Vznik pracovného vzťahu (dátum nástupu)' },
      { key: 'work_end', label: 'Zánik pracovného vzťahu (dátum ukončenia)' },
      { key: 'eldp', label: 'ELDP' },
      { key: 'questionnaire', label: 'Dotazník vyplnený' },
      { key: 'sp', label: 'Sociálna poisťovňa – prihlásenie' },
      { key: 'sp_end', label: 'Sociálna poisťovňa – odhlásenie' },
      ...(isBrigade ? [] : [
        { key: 'zp', label: 'Zdravotná poisťovňa – prihlásenie' },
        { key: 'zp_end', label: 'Zdravotná poisťovňa – odhlásenie' }
      ]),
      { key: 'bozp', label: 'Vyhlásenie k dani' },
      { key: 'no_wage_confirm', label: 'Potvrdenie o zdaniteľnej mzde' },
      { key: 'annual_tax', label: 'Ročné zúčtovanie dane' },
      { key: 'socpoist_declaration', label: 'Vyhlásenie o odpočítateľnej položke SP' },
      { key: 'paid_complete', label: 'Vybavené komplet' },
      ...(isBrigade ? [
        { key: 'school_confirm', label: 'Potvrdenie o návšteve školy' }
      ] : []),
      ...(isInvalid ? [
        { key: 'invalidity_confirm', label: 'Potvrdenie o invalidite' }
      ] : [])
    ];

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <title>Karta zamestnanca - ${emp.firstName} ${emp.lastName}</title>
        <style>
          @media print {
            @page { 
              margin: 0.8cm; 
              size: A4;
            }
            body { 
              margin: 0; 
              zoom: 0.75; /* Zmenšené na 75% pre 2 strany */
            }
          }
          body {
            font-family: Arial, sans-serif;
            font-size: 9pt;
            line-height: 1.2;
            color: #000;
            background: #fff;
            padding: 12px;
          }
          h1 {
            font-size: 14pt;
            margin: 0 0 6px 0;
            border-bottom: 2px solid #000;
            padding-bottom: 4px;
          }
          h2 {
            font-size: 11pt;
            margin: 8px 0 4px 0;
            background: #f0f0f0;
            padding: 3px 6px;
            border-left: 3px solid #333;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 4px 0;
          }
          th, td {
            border: 1px solid #333;
            padding: 3px 4px;
            text-align: left;
            font-size: 8pt;
          }
          th {
            background: #e0e0e0;
            font-weight: 600;
          }
          .section {
            page-break-inside: avoid;
            margin-bottom: 6px;
          }
          .footer {
            margin-top: 15px;
            padding-top: 6px;
            border-top: 1px solid #999;
            font-size: 7pt;
            color: #666;
          }
          .status-required { color: #c00; font-weight: 600; }
          .status-optional { color: #666; }
          .status-done { color: #060; font-weight: 600; }
          .checkbox { 
            font-size: 12pt; 
            font-family: "Segoe UI Symbol", "Arial Unicode MS", sans-serif;
            display: inline-block;
            width: 16px;
            text-align: center;
          }
        </style>
      </head>
      <body>
        <h1>📋 Karta zamestnanca ${(emp.firstName || '').toUpperCase()} ${(emp.lastName || '').toUpperCase()}</h1>
        <p><strong>PIN:</strong> ${emp.pin || ''} | <strong>Vytlačené:</strong> ${new Date().toLocaleString('sk-SK')}</p>

        <div class="section">
          <h2>👤 Osobné údaje</h2>
          <table>
            <tr><td><strong>Meno a priezvisko:</strong></td><td>${emp.titleBefore || ''} ${emp.firstName || ''} ${emp.lastName || ''} ${emp.titleAfter || ''}</td></tr>
            <tr><td><strong>Rodné priezvisko:</strong></td><td>${emp.birth_lastname || ''}</td></tr>
            <tr><td><strong>Dátum narodenia:</strong></td><td>${emp.birthDate || ''}</td></tr>
            <tr><td><strong>Rodné číslo:</strong></td><td>${emp.rodne_cislo || ''}</td></tr>
            <tr><td><strong>Miesto narodenia:</strong></td><td>${emp.birth_place || ''}</td></tr>
            <tr><td><strong>Národnosť:</strong></td><td>${emp.nationality || ''}</td></tr>
            <tr><td><strong>Štátna príslušnosť:</strong></td><td>${emp.state_citizenship || ''} ${emp.state_citizenship_other || ''}</td></tr>
            <tr><td><strong>Číslo OP:</strong></td><td>${emp.id_card || ''}</td></tr>
            <tr><td><strong>Rodinný stav:</strong></td><td>${emp.marital_status || ''}</td></tr>
          </table>
        </div>

        <div class="section">
          <h2>📍 Kontaktné údaje</h2>
          <table>
            <tr><td><strong>Adresa:</strong></td><td>${emp.street_name || ''} ${emp.cislo_domu || ''}, ${emp.zip || ''} ${emp.city || ''}</td></tr>
            <tr><td><strong>Telefón:</strong></td><td>${emp.phone || ''}</td></tr>
            <tr><td><strong>Email:</strong></td><td>${emp.email || ''}</td></tr>
          </table>
        </div>

        <div class="section">
          <h2>💼 Pracovný pomer</h2>
          <table>
            <tr><td><strong>Spoločnosť:</strong></td><td>${emp.company || ''}</td></tr>
            <tr><td><strong>Pozícia:</strong></td><td>${emp.position || ''}</td></tr>
            <tr><td><strong>Typ zmluvy:</strong></td><td>${emp.contractType || ''}</td></tr>
            <tr><td><strong>Úväzok (hod/týždeň):</strong></td><td>${emp.dohodnuty_uvazok || ''}</td></tr>
            <tr><td><strong>Dátum nástupu:</strong></td><td>${emp.startDate || ''}</td></tr>
            <tr><td><strong>Doba trvania:</strong></td><td>${emp.contract_duration_type || ''}</td></tr>
            <tr><td><strong>Mzda (brutto):</strong></td><td>${emp.wage_brutto || ''} € (${emp.wage_type || ''})</td></tr>
            <tr><td><strong>Skúšobná doba:</strong></td><td>${yn(emp.has_trial_period)}</td></tr>
          </table>
        </div>

        <div class="section">
          <h2>🏥 Zdravie a poistenie</h2>
          <table>
            <tr><td><strong>Zdravotná poisťovňa:</strong></td><td>${emp.insurance || ''} ${emp.insurance_other || ''}</td></tr>
            <tr><td><strong>Zdravotné obmedzenia:</strong></td><td>${yn(emp.has_health_issues)} ${emp.health_notes || ''}</td></tr>
          </table>
        </div>

        <div class="section">
          <h2>💰 Dane a rodina</h2>
          <table>
            <tr><td><strong>Počet detí:</strong></td><td>${emp.children_count || '0'}</td></tr>
            <tr><td><strong>Daňový bonus:</strong></td><td>${yn(emp.tax_bonus)}</td></tr>
            <tr><td><strong>Daňová úľava:</strong></td><td>${yn(emp.tax_vyhlasenie)}</td></tr>
          </table>
        </div>

        <div class="section">
          <h2>🏦 Bankové údaje</h2>
          <table>
            <tr><td><strong>Banka:</strong></td><td>${emp.bank_name || ''}</td></tr>
            <tr><td><strong>IBAN:</strong></td><td>${emp.bank_iban || ''}</td></tr>
          </table>
        </div>

        <div class="section">
          <h2>📋 Povinnosti a termíny</h2>
          <table>
            <thead>
              <tr>
                <th>Povinnosť</th>
                <th style="width: 80px;">Typ</th>
                <th style="width: 80px;">Splnené</th>
                <th style="width: 100px;">Dátum</th>
                <th>Poznámka</th>
              </tr>
            </thead>
            <tbody>
              ${obligationItems.map(item => {
      const obl = obligations[item.key] || {};
      const done = !!(obl.done === true || obl.done === '1' || obl.done === 1);
      const required = !!(obl.required === true || obl.required === '1' || obl.required === 1);
      const optional = !!(obl.optional === true || obl.optional === '1' || obl.optional === 1);
      const type = required ? '<span class="status-required">Povinné</span>' : (optional ? '<span class="status-optional">Nepovinné</span>' : '');
      // Zobrazenie: ak je splnené → zaškrtnuté políčko, inak prázdne políčko (☐)
      const status = done ? '<span class="status-done checkbox">☑</span>' : '<span class="checkbox">☐</span>';
      const date = obl.date || '';
      const note = obl.notes || '';
      return `<tr>
                  <td>${item.label}</td>
                  <td>${type}</td>
                  <td>${status}</td>
                  <td>${date}</td>
                  <td>${note}</td>
                </tr>`;
    }).join('')}
            </tbody>
          </table>
        </div>

        <div class="section">
          <h2>📌 Štatút</h2>
          <table>
            <tr><td><strong>Som študent:</strong></td><td>${yn(emp.is_student)}</td></tr>
            <tr><td><strong>Som dôchodca:</strong></td><td>${yn(emp.is_pensioner)}</td></tr>
            <tr><td><strong>Som invalidný dôchodca:</strong></td><td>${yn(emp.is_invalid_pensioner)}</td></tr>
            <tr><td><strong>Som evidovaný na ÚP:</strong></td><td>${yn(emp.is_registered_unemployment)}</td></tr>
          </table>
        </div>

        ${emp.notes ? `
        <div class="section">
          <h2>📝 Poznámky</h2>
          <p>${(emp.notes || '').replace(/\n/g, '<br>')}</p>
        </div>
        ` : ''}

        <div class="footer">
          Vygenerované: ${new Date().toLocaleString('sk-SK')} | Personalistický systém | uctovnictvo-poprad.sk
        </div>

        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
            }, 250);
          };
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Registrácia nového zamestnanca - expanded questionnaire
  const handleRegister = async (e, skipEmail = false) => {
    e.preventDefault();
    console.log('handleRegister called, skipEmail:', skipEmail);
    setSaving(true);
    try {

      const form = new FormData(e.target);
      const obj = {};
      for (const [k, v] of form.entries()) {
        // normalize checkboxes
        if (obj[k] !== undefined) {
          if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
          obj[k].push(v);
        } else {
          obj[k] = v;
        }
      }

      // Explicitne uložiť hodnoty selectov, ak by neboli v objekte (niektoré browsery ich nevracajú ak nie sú zmenené)
      const selectFields = ['insurance', 'insurance_other', 'tax_bonus', 'tax_vyhlasenie'];
      selectFields.forEach(field => {
        const el = e.target.elements[field];
        if (el && !obj[field]) {
          obj[field] = el.value;
        }
      });

      // Ensure GDPR consent
      if (!obj.consent_gdpr) {
        throw new Error('Je potrebné súhlasiť so spracovaním osobných údajov (GDPR)');
      }

      // Remove file inputs from object (they will be uploaded separately)
      const filtered = {};
      for (const k of Object.keys(obj)) {
        if (k.startsWith('upload_') || k === 'file' || k === 'files') continue;
        filtered[k] = obj[k];
      }

      // Client-side validation before sending to server
      const { valid, errors: clientErrors } = validateAll(filtered, skipEmail);
      if (!valid) {
        console.log('Validation failed:', clientErrors);
        alert('Vyplňte všetky povinné polia (označené červenou hviezdičkou)');
        setErrors(clientErrors);
        // focus first missing field if present
        const first = Object.keys(clientErrors)[0];
        const el = document.querySelector(`[name="${first}"]`);
        if (el && typeof el.focus === 'function') el.focus();
        setSaving(false);
        return;
      } else {
        setErrors({});
      }

      // Ensure pin exists and is exactly 4 digits
      const pin = (filtered.pin || '').toString().replace(/\D/g, '').slice(0, 4);
      if (!/^[0-9]{4}$/.test(pin)) {
        throw new Error('PIN musí byť presne 4 číslice');
      }

      // First register the PIN
      const reg = await fetch(REGISTER_PIN, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin })
      });
      if (!reg.ok) {
        const txt = await reg.text();
        throw new Error(txt || 'Chyba pri registrácii PIN');
      }

      // attach pin and metadata into saved object explicitly
      filtered.pin = pin;
      filtered.filled_by = filtered.filled_by || (isAdmin ? 'admin' : 'web_form');
      filtered.filled_on = new Date().toISOString();

      // Save full employee object to server (excluding file contents)
      const save = await fetch(EMPLOYEES_API + `?action=save&pin=${encodeURIComponent(pin)}&allow_overwrite=true`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(filtered)
      });
      if (!save.ok) {
        const txt = await save.text();
        let errorMsg = 'Chyba pri ukladaní zamestnanca';
        try {
          const errJson = JSON.parse(txt);
          if (errJson.error) errorMsg = errJson.error;
        } catch (e) {
          // If not JSON, use raw text
          if (txt) errorMsg = txt;
        }
        throw new Error(errorMsg);
      }
      const jr = await save.json();
      if (jr.success) {
        // Send email notification ONLY if NOT skipEmail mode
        if (!skipEmail) {
          try {
            await fetch(SEND_NOTIFICATION, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ pin })
            });
          } catch (emailErr) {
            console.error('Email notification failed:', emailErr);
            // Don't block registration if email fails
          }
        }

        // After save, load the saved employee record and open detail
        const loadRes = await fetch(EMPLOYEES_API + `?action=load&pin=${encodeURIComponent(pin)}`);
        const loadText = await loadRes.text();
        let saved = null;
        try { saved = JSON.parse(loadText); } catch (e) { saved = null; }

        // If skipEmail (admin registration), close form and refresh list
        if (skipEmail) {
          setShowNewEmployeeForm(false);
          alert('Zamestnanec bol úspešne pridaný (email nebol odoslaný)');
          if (isAdmin) {
            fetchEmployees();
          }
          e.target.reset();
          setSaving(false);
          return;
        }

        // set UI state: authenticated as this employee and show their detail
        setIsAuthenticated(true);
        setIsAdmin(false);
        setCurrentEmployee(saved || filtered);
        // clear form
        e.target.reset();

        // Ask if employee wants login credentials via email
        const employeeEmail = filtered.email;
        if (employeeEmail && window.confirm('Registrácia úspešná. Chcete zaslať prihlasovacie údaje (PIN) na email ' + employeeEmail + '?')) {
          try {
            const emailRes = await fetch('/php/send_employee_welcome.php', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                pin: pin,
                email: employeeEmail,
                firstName: filtered.firstName || '',
                lastName: filtered.lastName || ''
              })
            });
            const emailData = await emailRes.json();
            if (emailData.success) {
              alert('Email s prihlasovacími údajmi bol odoslaný na ' + employeeEmail);
            } else {
              alert('Nepodarilo sa odoslať email: ' + (emailData.error || 'Neznáma chyba'));
            }
          } catch (emailErr) {
            console.error('Email send failed:', emailErr);
            alert('Nepodarilo sa odoslať email');
          }
        }

        // Prílohy môžu byť nahrané kedykoľvek neskôr cez "Moje dokumenty"
        // Neotvárame file dialog automaticky po registrácii
      } else {
        throw new Error(jr.error || 'Server vrátil chybu');
      }
    } catch (err) {
      alert('Chyba: ' + (err.message || err));
    } finally {
      setSaving(false);
    }
  };

  // Odhlásenie
  const handleLogout = () => {
    setIsAuthenticated(false);
    setIsAdmin(false);
    setCurrentEmployee(null);
    setEmployees([]);
    setPinInput("");
  };

  // UI
  if (!isAuthenticated) {
    return (
      <>
        <style>{`
          input:focus, select:focus, textarea:focus {
            outline: none !important;
            border-color: #3b82f6 !important;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
            transform: none !important;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
          }
          @media (max-width: 800px) {
            .personalistika-layout {
              grid-template-columns: 1fr !important;
              grid-template-areas: "form" "side" !important;
            }
          }
          .personalistika-layout .form-card .form-table input,
          .personalistika-layout .form-card .form-table select,
          .personalistika-layout .form-card .form-table textarea {
            width: 100% !important;
            max-width: 520px;
          }
          .personalistika-layout .form-card .form-table tr {
            display: block;
          }
          .personalistika-layout .form-card .form-table,
          .personalistika-layout .form-card .form-table tbody {
            display: block;
            width: 560px !important;
            max-width: 100%;
          }
          .personalistika-layout .form-card .form-table td {
            display: block;
            width: 100% !important;
            box-sizing: border-box;
          }
          .personalistika-layout .form-card .form-table td:first-child {
            padding-bottom: 2px !important;
          }
          .personalistika-layout .form-card .form-table td:nth-child(2) {
            padding-top: 2px !important;
            width: 540px !important;
            max-width: 100%;
          }
          .personalistika-layout aside form > div {
            flex-direction: column;
            align-items: stretch !important;
          }
          .personalistika-layout aside form input,
          .personalistika-layout aside form button {
            width: 100%;
            box-sizing: border-box;
          }
          @media (max-width: 800px) {
            .personalistika-layout .form-card .form-table input,
            .personalistika-layout .form-card .form-table select,
            .personalistika-layout .form-card .form-table textarea {
              width: 100% !important;
              max-width: 100%;
            }
            .personalistika-layout .form-card .form-table,
            .personalistika-layout .form-card .form-table tbody,
            .personalistika-layout .form-card .form-table td:nth-child(2) {
              width: 100% !important;
            }
          }
        `}</style>
        <div style={{ width: 'calc(100% - 32px)', maxWidth: 1200, margin: "2rem auto", background: "#fff", borderRadius: 8, padding: 20, boxSizing: 'border-box', boxShadow: "0 2px 16px #0001" }}>
          <h2 style={{ textAlign: 'center' }}>Prihlásenie / Registrácia zamestnanca</h2>

          <div className="personalistika-layout" style={{ display: 'grid', gridTemplateColumns: loginPanelOpen ? 'minmax(0, 680px) 300px' : 'minmax(0, 680px) 120px', gridTemplateAreas: '"form side"', gap: 20, alignItems: 'start', justifyContent: 'center' }}>

        {/* Login panel beside the registration form */}
        <aside style={{ gridArea: 'side' }}>
        <button
          type="button"
          onClick={() => setLoginPanelOpen(open => !open)}
          aria-expanded={loginPanelOpen}
          style={{ width: '100%', marginBottom: loginPanelOpen ? 10 : 0, padding: '9px 8px', background: '#eef2f7', border: '1px solid #d8e0ea', borderRadius: 8, cursor: 'pointer', fontWeight: 600, color: '#243447', whiteSpace: 'nowrap' }}
        >
          {loginPanelOpen ? '‹ Skryť prihlásenie' : '› Prihlásenia'}
        </button>
        {loginPanelOpen && <>
        <div style={{ marginBottom: 20, padding: 16, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e5e7eb' }}>
          <h3 style={{ marginTop: 0 }}>🔒 Prihlásenie admina</h3>
          <form onSubmit={(e) => { e.preventDefault(); const u = e.target.adminUsername.value; const p = e.target.adminPassword.value; fetch(ADMIN_PORTAL + '?action=login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username: u, password: p }) }).then(r => r.json()).then(d => { if (d.success) { setIsAuthenticated(true); setIsAdmin(true); fetchEmployees(); } else { alert('Nesprávne prihlasovacie údaje'); } }).catch(() => alert('Chyba prihlásenia')); }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input name="adminUsername" placeholder="Užívateľské meno" required style={{ padding: '8px 12px', flex: 1, border: '1px solid #cbd5e1', borderRadius: 6 }} />
              <input name="adminPassword" type="password" placeholder="Heslo" required style={{ padding: '8px 12px', flex: 1, border: '1px solid #cbd5e1', borderRadius: 6 }} />
              <button type="submit" style={{ padding: '8px 16px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>Prihlásiť</button>
            </div>
          </form>
        </div>

        {/* Employee login inline */}
        <div style={{ marginBottom: 20, padding: 16, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e5e7eb' }}>
          <h3 style={{ marginTop: 0 }}>👤 Prihlásenie zamestnanca</h3>
          <form onSubmit={(e) => { e.preventDefault(); const pin = e.target.employeePin.value; fetch(`${EMPLOYEE_PORTAL}?action=login&pin=${encodeURIComponent(pin)}`).then(r => r.json()).then(d => { if (d.success && d.employee) { setIsAuthenticated(true); setIsAdmin(false); setCurrentEmployee(d.employee); } else { alert('Nesprávny PIN'); } }).catch(() => alert('Chyba prihlásenia')); }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input name="employeePin" placeholder="Zadajte 4-ciferný PIN" required inputMode="numeric" pattern="[0-9]{4}" maxLength={4} style={{ padding: '8px 12px', flex: 1, border: '1px solid #cbd5e1', borderRadius: 6 }} />
              <button type="submit" style={{ padding: '8px 16px', background: '#10b981', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>Prihlásiť</button>
            </div>
          </form>
        </div>
        </>}
        </aside>

        {/* Registration form only */}
        <div className="form-card" style={{ gridArea: 'form', margin: 0 }}>
          <h3>Registrácia nového zamestnanca (prijatie do práce)</h3>
          <form ref={formRef} onSubmit={handleRegister}>
            <table className="form-table" style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
              <colgroup>
                <col style={{ width: '35%' }} />
                <col style={{ width: '65%' }} />
              </colgroup>
              <tbody>
                {/* personal / identity details */}
                <tr>
                  <td style={{ padding: 6, width: '35%', verticalAlign: 'top' }}>E‑mail</td>
                  <td style={{ padding: 6 }}>
                    <input name="email" type="email" placeholder="E‑mail" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('email', e.target.value)} />
                    {errors.email && <div style={{ color: 'red', fontSize: 12 }}>{errors.email}</div>}
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Titul pred menom</td>
                  <td style={{ padding: 6 }}><input name="titleBefore" placeholder="Titul pred menom" style={{ width: '100%' }} /></td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Krstné meno</td>
                  <td style={{ padding: 6 }}>
                    <input name="firstName" placeholder="Krstné meno" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('firstName', e.target.value)} />
                    {errors.firstName && <div style={{ color: 'red', fontSize: 12 }}>{errors.firstName}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Priezvisko</td>
                  <td style={{ padding: 6 }}>
                    <input name="lastName" placeholder="Priezvisko" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('lastName', e.target.value)} />
                    {errors.lastName && <div style={{ color: 'red', fontSize: 12 }}>{errors.lastName}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Titul za menom</td>
                  <td style={{ padding: 6 }}><input name="titleAfter" placeholder="Titul za menom" style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Rodné priezvisko</td>
                  <td style={{ padding: 6 }}><input name="birth_lastname" placeholder="Rodné priezvisko" style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Dátum narodenia</td>
                  <td style={{ padding: 6 }}>
                    <input name="birthDate" type="date" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('birthDate', e.target.value)} />
                    {errors.birthDate && <div style={{ color: 'red', fontSize: 12 }}>{errors.birthDate}</div>}
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Rodné číslo</td>
                  <td style={{ padding: 6 }}>
                    <input name="rodne_cislo" placeholder="Rodné číslo" required inputMode="numeric" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('rodne_cislo', e.target.value)} />
                    {errors.rodne_cislo && <div style={{ color: 'red', fontSize: 12 }}>{errors.rodne_cislo}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Miesto narodenia</td>
                  <td style={{ padding: 6 }}>
                    <input name="birth_place" placeholder="Miesto narodenia" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('birth_place', e.target.value)} />
                    {errors.birth_place && <div style={{ color: 'red', fontSize: 12 }}>{errors.birth_place}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Národnosť</td>
                  <td style={{ padding: 6 }}>
                    <input name="nationality" placeholder="Národnosť" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('nationality', e.target.value)} />
                    {errors.nationality && <div style={{ color: 'red', fontSize: 12 }}>{errors.nationality}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Štátna príslušnosť</td>
                  <td style={{ padding: 6 }}>
                    <select name="state_citizenship" onChange={(e) => setStateOther(e.target.value === 'other')} required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('state_citizenship', e.target.value)}>
                      <option value="SR">SR</option>
                      <option value="other">Iné</option>
                    </select>
                    {errors.state_citizenship && <div style={{ color: 'red', fontSize: 12 }}>{errors.state_citizenship}</div>}
                  </td>
                </tr>
                {stateOther && (
                  <tr>
                    <td style={{ padding: 6 }}></td>
                    <td style={{ padding: 6 }}><input name="state_citizenship_other" placeholder="Uveďte štátnu príslušnosť" required style={{ width: '100%' }} /></td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: 6 }}>Číslo občianskeho preukazu</td>
                  <td style={{ padding: 6 }}>
                    <input name="id_card" placeholder="Číslo občianskeho preukazu" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('id_card', e.target.value)} />
                    {errors.id_card && <div style={{ color: 'red', fontSize: 12 }}>{errors.id_card}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Ulica</td>
                  <td style={{ padding: 6 }}>
                    <input name="street_name" placeholder="Ulica" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('street_name', e.target.value)} />
                    {errors.street_name && <div style={{ color: 'red', fontSize: 12 }}>{errors.street_name}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Číslo domu</td>
                  <td style={{ padding: 6 }}>
                    <input name="cislo_domu" placeholder="Číslo domu (súpisné/popisné)" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('cislo_domu', e.target.value)} />
                    {errors.cislo_domu && <div style={{ color: 'red', fontSize: 12 }}>{errors.cislo_domu}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Mesto trvalého pobytu</td>
                  <td style={{ padding: 6 }}>
                    <input name="city" placeholder="Mesto" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('city', e.target.value)} />
                    {errors.city && <div style={{ color: 'red', fontSize: 12 }}>{errors.city}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>PSČ</td>
                  <td style={{ padding: 6 }}>
                    <input name="zip" placeholder="PSČ" required inputMode="numeric" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('zip', e.target.value)} />
                    {errors.zip && <div style={{ color: 'red', fontSize: 12 }}>{errors.zip}</div>}
                  </td>
                </tr>


                <tr>
                  <td style={{ padding: 6 }}>Rodinný stav</td>
                  <td style={{ padding: 6 }}>
                    <select name="marital_status" style={{ width: '100%' }}>
                      <option value="">--</option>
                      <option value="single">Slobodný/á</option>
                      <option value="married">Ženatý/Vydatá</option>
                      <option value="divorced">Rozvedený/á</option>
                      <option value="widowed">Vdovec/Vdova</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Tel. číslo</td>
                  <td style={{ padding: 6 }}>
                    <input name="phone" type="tel" inputMode="tel" autoComplete="tel" placeholder="Tel. číslo" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('phone', e.target.value)} />
                    {errors.phone && <div style={{ color: 'red', fontSize: 12 }}>{errors.phone}</div>}
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Zdravotná poisťovňa</td>
                  <td style={{ padding: 6 }}>
                    <select name="insurance" onChange={(e) => setInsuranceOther(e.target.value === 'other')} required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('insurance', e.target.value)}>
                      <option value="VŠZP">VŠZP</option>
                      <option value="Dôvera">Dôvera</option>
                      <option value="Union">Union</option>
                      <option value="other">Iné</option>
                    </select>
                    {errors.insurance && <div style={{ color: 'red', fontSize: 12 }}>{errors.insurance}</div>}
                  </td>
                </tr>
                {insuranceOther && (
                  <tr>
                    <td style={{ padding: 6 }}></td>
                    <td style={{ padding: 6 }}><input name="insurance_other" placeholder="Iná poisťovňa" required style={{ width: '100%' }} /></td>
                  </tr>
                )}

                <tr>
                  <td style={{ padding: 6 }}>Banka</td>
                  <td style={{ padding: 6 }}>
                    <input name="bank_name" placeholder="Banka" style={{ width: '100%' }} />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>IBAN</td>
                  <td style={{ padding: 6 }}>
                    <input name="bank_iban" placeholder="IBAN" style={{ width: '100%' }} />
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Som študent</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_student" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_student" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Som poberateľom dôchodku</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_pensioner" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_pensioner" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Som poberateľom invalidného dôchodku</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_invalid_pensioner" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_invalid_pensioner" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Som evidovaná/ý na úrade práce</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_registered_unemployment" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_registered_unemployment" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Dohodnutá pracovná pozícia</td>
                  <td style={{ padding: 6 }}><input name="position" placeholder="Dohodnutá pracovná pozícia" required style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Skúšobná doba</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="has_trial_period" value="yes" /> Áno</label>
                    <label><input type="radio" name="has_trial_period" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>



                <tr>
                  <td style={{ padding: 6 }}>Dotazník vypisujem pre spoločnosť:</td>
                  <td style={{ padding: 6 }}>
                    <input name="company" placeholder="Názov spoločnosti" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('company', e.target.value)} />
                    {errors.company && <div style={{ color: 'red', fontSize: 12 }}>{errors.company}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Vyhlasujem, že som nič nezamlčal/a a všetky mnou uvedené údaje sú pravdivé</td>
                  <td style={{ padding: 6 }}><label><input type="checkbox" name="declaration_truth" value="1" required /> Áno</label></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Typ pracovného pomeru</td>
                  <td style={{ padding: 6 }}>
                    <select name="contractType" required onChange={(e) => {
                      const val = e.target.value;
                      setContractTypeValue(val);
                      setIsStudentBrigade(val === 'brigada');
                      setIsDohoda(val === 'dohoda_vykon' || val === 'dohoda_prac' || val === 'brigada');
                    }} style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('contractType', e.target.value)}>
                      <option value="">Vyberte typ pracovného pomeru</option>
                      <option value="plny_uvazok">plný úväzok</option>
                      <option value="skraty_uvazok">skrátený úväzok</option>
                      <option value="dohoda_vykon">dohoda o vykonaní práce - 350 hodín ročne</option>
                      <option value="dohoda_prac">dohoda o pracovnej činnosti - 10 hodín týždenne</option>
                      <option value="brigada">dohoda o brigádnickej práci študentov - priemerne 20 hod./týždeň</option>
                      <option value="zivnost">živnosť</option>
                    </select>
                    {errors.contractType && <div style={{ color: 'red', fontSize: 12 }}>{errors.contractType}</div>}
                  </td>
                </tr>
                {contractTypeValue === 'skraty_uvazok' && (
                  <tr>
                    <td style={{ padding: 6 }}>Pri skrátenom úväzku (hod./deň)</td>
                    <td style={{ padding: 6 }}><input name="part_time_hours_per_day" placeholder="Hodín za deň" required style={{ width: '100%' }} /></td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: 6 }}>Možný dátum nástupu do zamestnania</td>
                  <td style={{ padding: 6 }}><input name="startDate" type="date" required style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Dohodnutý úväzok (hod./týždeň)</td>
                  <td style={{ padding: 6 }}><input name="dohodnuty_uvazok" type="number" required placeholder="Dohodnutý úväzok" style={{ width: '100%' }} /></td>
                </tr>

                {/* Salary / contract details */}
                <tr>
                  <td style={{ padding: 6 }}>Typ mzdy za prácu</td>
                  <td style={{ padding: 6 }}>
                    <select name="wage_type" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('wage_type', e.target.value)}>
                      <option value="">Vyberte typ mzdy</option>
                      <option value="hourly">hodinová</option>
                      <option value="monthly">mesačná</option>
                    </select>
                    {errors.wage_type && <div style={{ color: 'red', fontSize: 12 }}>{errors.wage_type}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Dohodnutá mzda brutto (€)</td>
                  <td style={{ padding: 6 }}>
                    <input name="wage_brutto" type="number" step="0.01" placeholder="Brutto (€)" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('wage_brutto', e.target.value)} />
                    {errors.wage_brutto && <div style={{ color: 'red', fontSize: 12 }}>{errors.wage_brutto}</div>}
                  </td>
                </tr>
                {!isDohoda && (
                  <tr>
                    <td style={{ padding: 6 }}>Doba trvania pracovnej zmluvy</td>
                    <td style={{ padding: 6 }}>
                      <select name="contract_duration_type" required style={{ width: '100%' }}>
                        <option value="">--</option>
                        <option value="urcita">určitá</option>
                        <option value="neurcita">neurčitá</option>
                      </select>
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: 6 }}>Úľava na dani</td>
                  <td style={{ padding: 6 }}><label><input type="checkbox" name="tax_vyhlasenie" value="1" /> Chcem si uplatniť úľavu na dani (podpis vyhlásenia)</label></td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Počet detí</td>
                  <td style={{ padding: 6 }}><input name="children_count" type="number" placeholder="Počet detí" min="0" defaultValue={0} required
                    onChange={(e) => setChildrenCount(parseInt(e.target.value || '0', 10) || 0)} style={{ width: '100%' }} /></td>
                </tr>

                {childrenCount > 0 && (
                  <tr>
                    <td style={{ padding: 6 }}>Daňový bonus</td>
                    <td style={{ padding: 6 }}>
                      <label><input type="checkbox" name="tax_bonus" value="yes" /> Áno</label>
                    </td>
                  </tr>
                )}

                <tr>
                  <td style={{ padding: 6 }}>Máte zdravotné obmedzenia / alergie?</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}>
                      <input
                        type="radio"
                        name="has_health_issues"
                        value="yes"
                        onChange={(e) => setHasHealthIssues(e.target.value === 'yes')}
                      /> Áno
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="has_health_issues"
                        value="no"
                        defaultChecked
                        onChange={(e) => setHasHealthIssues(e.target.value === 'yes')}
                      /> Nie
                    </label>
                  </td>
                </tr>

                {hasHealthIssues && (
                  <>
                    <tr>
                      <td style={{ padding: 6 }}>Zdravotné obmedzenia / alergie</td>
                      <td style={{ padding: 6 }}><input name="health_notes" placeholder="Zdravotné obmedzenia / alergie" required style={{ width: '100%' }} /></td>
                    </tr>
                    <tr>
                      <td style={{ padding: 6 }}></td>
                      <td style={{ padding: 6 }}><div style={{ color: '#a00', fontWeight: 600 }}>Poznámka: Môže byť vyžiadané lekárske potvrdenie k uvedeným obmedzeniam.</div></td>
                    </tr>
                  </>
                )}

                <tr>
                  <td style={{ padding: 6 }}>Súhlas so spracovaním osobných údajov (GDPR)</td>
                  <td style={{ padding: 6 }}><label><input type="checkbox" name="consent_gdpr" value="1" required /> Súhlasím so spracovaním osobných údajov</label></td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>PIN</td>
                  <td style={{ padding: 6 }}>
                    <input name="pin" type="password" placeholder="PIN (4 číslice)" pattern="\d{4,6}" required title="PIN musí obsahovať 4 číslice" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('pin', e.target.value)} />
                    {errors.pin && <div style={{ color: 'red', fontSize: 12 }}>{errors.pin}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Použitie PIN kódu</td>
                  <td style={{ padding: 6, color: '#333' }}>
                    <div>Tento PIN bude zároveň PIN kódom pre otváranie výplatných pások zasielaných elektronicky.</div>
                    <div style={{ marginTop: 6, fontSize: 13, color: '#666' }}>Súbory (doklady) nahrávajte až po úspešnej registrácii v sekcii dokumentov.</div>
                  </td>
                </tr>


                <tr>
                  <td style={{ padding: 6 }}>Poznámky</td>
                  <td style={{ padding: 6 }}><textarea name="notes" placeholder="Poznámky" style={{ width: '100%' }} /></td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
              <button type="submit" className="button-primary" disabled={saving}>{saving ? 'Ukladám...' : 'Registrovať a uložiť'}</button>
              <button type="button" onClick={() => { formRef.current && formRef.current.reset(); setHasHealthIssues(false); }}>Vymazať</button>
            </div>
          </form>
        </div>
      </div>
      </div>
      </>
    );
  }

  // Po prihlásení - zamestnanec vidí svoje údaje, personalista všetkých
  return (
    <div style={{ padding: 20, maxWidth: '66%', margin: '0 auto' }}>
      <h2>Personalistika</h2>
      <div style={{ marginBottom: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
        <button onClick={handleLogout} style={ui.btnGhost}>Odhlásiť</button>
        {isAdmin && <button style={ui.btn} onClick={fetchEmployees}>Načítať zamestnancov</button>}
        {isAdmin && <button style={ui.btn} onClick={() => setShowNewEmployeeForm(!showNewEmployeeForm)}>
          {showNewEmployeeForm ? 'Zrušiť' : '+ Nový zamestnanec'}
        </button>}
        {isAdmin && (
          <input placeholder="Hľadať meno alebo PIN" value={search} onChange={e => setSearch(e.target.value)}
            style={{ marginLeft: 'auto', padding: '8px 12px', borderRadius: 8, border: '1px solid #e5e7eb' }} />
        )}
      </div>
      {isAdmin && showNewEmployeeForm && (
        <div style={{ ...ui.card, marginBottom: 16, backgroundColor: '#fffbeb', border: '2px solid #fbbf24' }}>
          <h3 style={{ marginTop: 0 }}>Pridať nového zamestnanca</h3>
          <p style={{ fontSize: 13, color: '#92400e', marginBottom: 16 }}>
            ⚠️ Email nebude odoslaný zamestnancovi. PIN musíte odovzdať manuálne.
          </p>
          <form ref={formRef} onSubmit={(e) => handleRegister(e, true)}>
            <table className="form-table" style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
              <colgroup>
                <col style={{ width: '35%' }} />
                <col style={{ width: '65%' }} />
              </colgroup>
              <tbody>
                {/* personal / identity details – IDENTICKÉ S REGISTRAČNÝM FORMULÁROM */}
                <tr>
                  <td style={{ padding: 6, width: '35%', verticalAlign: 'top' }}>E‑mail (nepovinné)</td>
                  <td style={{ padding: 6 }}>
                    <input name="email" type="email" placeholder="E‑mail (nepovinné)" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('email', e.target.value)} />
                    {errors.email && <div style={{ color: 'red', fontSize: 12 }}>{errors.email}</div>}
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Titul pred menom</td>
                  <td style={{ padding: 6 }}><input name="titleBefore" placeholder="Titul pred menom" style={{ width: '100%' }} /></td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Krstné meno</td>
                  <td style={{ padding: 6 }}>
                    <input name="firstName" placeholder="Krstné meno" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('firstName', e.target.value)} />
                    {errors.firstName && <div style={{ color: 'red', fontSize: 12 }}>{errors.firstName}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Priezvisko</td>
                  <td style={{ padding: 6 }}>
                    <input name="lastName" placeholder="Priezvisko" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('lastName', e.target.value)} />
                    {errors.lastName && <div style={{ color: 'red', fontSize: 12 }}>{errors.lastName}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Titul za menom</td>
                  <td style={{ padding: 6 }}><input name="titleAfter" placeholder="Titul za menom" style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Rodné priezvisko</td>
                  <td style={{ padding: 6 }}><input name="birth_lastname" placeholder="Rodné priezvisko" style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Dátum narodenia</td>
                  <td style={{ padding: 6 }}>
                    <input name="birthDate" type="date" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('birthDate', e.target.value)} />
                    {errors.birthDate && <div style={{ color: 'red', fontSize: 12 }}>{errors.birthDate}</div>}
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Rodné číslo</td>
                  <td style={{ padding: 6 }}>
                    <input name="rodne_cislo" placeholder="Rodné číslo" required inputMode="numeric" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('rodne_cislo', e.target.value)} />
                    {errors.rodne_cislo && <div style={{ color: 'red', fontSize: 12 }}>{errors.rodne_cislo}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Miesto narodenia</td>
                  <td style={{ padding: 6 }}>
                    <input name="birth_place" placeholder="Miesto narodenia" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('birth_place', e.target.value)} />
                    {errors.birth_place && <div style={{ color: 'red', fontSize: 12 }}>{errors.birth_place}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Národnosť</td>
                  <td style={{ padding: 6 }}>
                    <input name="nationality" placeholder="Národnosť" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('nationality', e.target.value)} />
                    {errors.nationality && <div style={{ color: 'red', fontSize: 12 }}>{errors.nationality}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Štátna príslušnosť</td>
                  <td style={{ padding: 6 }}>
                    <select name="state_citizenship" onChange={(e) => setStateOther(e.target.value === 'other')} required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('state_citizenship', e.target.value)}>
                      <option value="SR">SR</option>
                      <option value="other">Iné</option>
                    </select>
                    {errors.state_citizenship && <div style={{ color: 'red', fontSize: 12 }}>{errors.state_citizenship}</div>}
                  </td>
                </tr>
                {stateOther && (
                  <tr>
                    <td style={{ padding: 6 }}></td>
                    <td style={{ padding: 6 }}><input name="state_citizenship_other" placeholder="Uveďte štátnu príslušnosť" required style={{ width: '100%' }} /></td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: 6 }}>Číslo občianskeho preukazu</td>
                  <td style={{ padding: 6 }}>
                    <input name="id_card" placeholder="Číslo občianskeho preukazu" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('id_card', e.target.value)} />
                    {errors.id_card && <div style={{ color: 'red', fontSize: 12 }}>{errors.id_card}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Ulica</td>
                  <td style={{ padding: 6 }}>
                    <input name="street_name" placeholder="Ulica" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('street_name', e.target.value)} />
                    {errors.street_name && <div style={{ color: 'red', fontSize: 12 }}>{errors.street_name}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Číslo domu</td>
                  <td style={{ padding: 6 }}>
                    <input name="cislo_domu" placeholder="Číslo domu (súpisné/popisné)" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('cislo_domu', e.target.value)} />
                    {errors.cislo_domu && <div style={{ color: 'red', fontSize: 12 }}>{errors.cislo_domu}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Mesto trvalého pobytu</td>
                  <td style={{ padding: 6 }}>
                    <input name="city" placeholder="Mesto" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('city', e.target.value)} />
                    {errors.city && <div style={{ color: 'red', fontSize: 12 }}>{errors.city}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>PSČ</td>
                  <td style={{ padding: 6 }}>
                    <input name="zip" placeholder="PSČ" required inputMode="numeric" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('zip', e.target.value)} />
                    {errors.zip && <div style={{ color: 'red', fontSize: 12 }}>{errors.zip}</div>}
                  </td>
                </tr>


                <tr>
                  <td style={{ padding: 6 }}>Rodinný stav</td>
                  <td style={{ padding: 6 }}>
                    <select name="marital_status" style={{ width: '100%' }}>
                      <option value="">--</option>
                      <option value="single">Slobodný/á</option>
                      <option value="married">Ženatý/Vydatá</option>
                      <option value="divorced">Rozvedený/á</option>
                      <option value="widowed">Vdovec/Vdova</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Tel. číslo</td>
                  <td style={{ padding: 6 }}>
                    <input name="phone" type="tel" inputMode="tel" autoComplete="tel" placeholder="Tel. číslo" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('phone', e.target.value)} />
                    {errors.phone && <div style={{ color: 'red', fontSize: 12 }}>{errors.phone}</div>}
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Zdravotná poisťovňa</td>
                  <td style={{ padding: 6 }}>
                    <select name="insurance" onChange={(e) => setInsuranceOther(e.target.value === 'other')} required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('insurance', e.target.value)}>
                      <option value="VŠZP">VŠZP</option>
                      <option value="Dôvera">Dôvera</option>
                      <option value="Union">Union</option>
                      <option value="other">Iné</option>
                    </select>
                    {errors.insurance && <div style={{ color: 'red', fontSize: 12 }}>{errors.insurance}</div>}
                  </td>
                </tr>
                {insuranceOther && (
                  <tr>
                    <td style={{ padding: 6 }}></td>
                    <td style={{ padding: 6 }}><input name="insurance_other" placeholder="Iná poisťovňa" required style={{ width: '100%' }} /></td>
                  </tr>
                )}

                <tr>
                  <td style={{ padding: 6 }}>Banka</td>
                  <td style={{ padding: 6 }}>
                    <input name="bank_name" placeholder="Banka" style={{ width: '100%' }} />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>IBAN</td>
                  <td style={{ padding: 6 }}>
                    <input name="bank_iban" placeholder="IBAN" style={{ width: '100%' }} />
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Som študent</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_student" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_student" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Som poberateľom dôchodku</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_pensioner" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_pensioner" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Som poberateľom invalidného dôchodku</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_invalid_pensioner" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_invalid_pensioner" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Som evidovaná/ý na úrade práce</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="is_registered_unemployment" value="yes" /> Áno</label>
                    <label><input type="radio" name="is_registered_unemployment" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Dohodnutá pracovná pozícia</td>
                  <td style={{ padding: 6 }}><input name="position" placeholder="Dohodnutá pracovná pozícia" required style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Skúšobná doba</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}><input type="radio" name="has_trial_period" value="yes" /> Áno</label>
                    <label><input type="radio" name="has_trial_period" value="no" defaultChecked /> Nie</label>
                  </td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Dotazník vypisujem pre spoločnosť:</td>
                  <td style={{ padding: 6 }}>
                    <input name="company" placeholder="Názov spoločnosti" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('company', e.target.value)} />
                    {errors.company && <div style={{ color: 'red', fontSize: 12 }}>{errors.company}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Vyhlasujem, že som nič nezamlčal/a a všetky mnou uvedené údaje sú pravdivé</td>
                  <td style={{ padding: 6 }}><label><input type="checkbox" name="declaration_truth" value="1" required /> Áno</label></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Typ pracovného pomeru</td>
                  <td style={{ padding: 6 }}>
                    <select name="contractType" required onChange={(e) => {
                      const val = e.target.value;
                      setContractTypeValue(val);
                      setIsStudentBrigade(val === 'brigada');
                      setIsDohoda(val === 'dohoda_vykon' || val === 'dohoda_prac' || val === 'brigada');
                    }} style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('contractType', e.target.value)}>
                      <option value="">Vyberte typ pracovného pomeru</option>
                      <option value="plny_uvazok">plný úväzok</option>
                      <option value="skraty_uvazok">skrátený úväzok</option>
                      <option value="dohoda_vykon">dohoda o vykonaní práce - 350 hodín ročne</option>
                      <option value="dohoda_prac">dohoda o pracovnej činnosti - 10 hodín týždenne</option>
                      <option value="brigada">dohoda o brigádnickej práci študentov - priemerne 20 hod./týždeň</option>
                      <option value="zivnost">živnosť</option>
                    </select>
                    {errors.contractType && <div style={{ color: 'red', fontSize: 12 }}>{errors.contractType}</div>}
                  </td>
                </tr>
                {contractTypeValue === 'skraty_uvazok' && (
                  <tr>
                    <td style={{ padding: 6 }}>Pri skrátenom úväzku (hod./deň)</td>
                    <td style={{ padding: 6 }}><input name="part_time_hours_per_day" placeholder="Hodín za deň" required style={{ width: '100%' }} /></td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: 6 }}>Možný dátum nástupu do zamestnania</td>
                  <td style={{ padding: 6 }}><input name="startDate" type="date" required style={{ width: '100%' }} /></td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Dohodnutý úväzok (hod./týždeň)</td>
                  <td style={{ padding: 6 }}><input name="dohodnuty_uvazok" type="number" required placeholder="Dohodnutý úväzok" style={{ width: '100%' }} /></td>
                </tr>

                {/* Salary / contract details */}
                <tr>
                  <td style={{ padding: 6 }}>Typ mzdy za prácu</td>
                  <td style={{ padding: 6 }}>
                    <select name="wage_type" required style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('wage_type', e.target.value)}>
                      <option value="">Vyberte typ mzdy</option>
                      <option value="hourly">hodinová</option>
                      <option value="monthly">mesačná</option>
                    </select>
                    {errors.wage_type && <div style={{ color: 'red', fontSize: 12 }}>{errors.wage_type}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Dohodnutá mzda brutto (€)</td>
                  <td style={{ padding: 6 }}>
                    <input name="wage_brutto" type="number" step="0.01" placeholder="Brutto (€)" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('wage_brutto', e.target.value)} />
                    {errors.wage_brutto && <div style={{ color: 'red', fontSize: 12 }}>{errors.wage_brutto}</div>}
                  </td>
                </tr>
                {!isDohoda && (
                  <tr>
                    <td style={{ padding: 6 }}>Doba trvania pracovnej zmluvy</td>
                    <td style={{ padding: 6 }}>
                      <select name="contract_duration_type" required style={{ width: '100%' }}>
                        <option value="">--</option>
                        <option value="urcita">určitá</option>
                        <option value="neurcita">neurčitá</option>
                      </select>
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: 6 }}>Úľava na dani</td>
                  <td style={{ padding: 6 }}><label><input type="checkbox" name="tax_vyhlasenie" value="1" /> Chcem si uplatniť úľavu na dani (podpis vyhlásenia)</label></td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>Počet detí</td>
                  <td style={{ padding: 6 }}><input name="children_count" type="number" placeholder="Počet detí" min="0" defaultValue={0} required
                    onChange={(e) => setChildrenCount(parseInt(e.target.value || '0', 10) || 0)} style={{ width: '100%' }} /></td>
                </tr>

                {childrenCount > 0 && (
                  <tr>
                    <td style={{ padding: 6 }}>Daňový bonus</td>
                    <td style={{ padding: 6 }}>
                      <label><input type="checkbox" name="tax_bonus" value="yes" /> Áno</label>
                    </td>
                  </tr>
                )}

                <tr>
                  <td style={{ padding: 6 }}>Máte zdravotné obmedzenia / alergie?</td>
                  <td style={{ padding: 6 }}>
                    <label style={{ marginRight: 16 }}>
                      <input
                        type="radio"
                        name="has_health_issues"
                        value="yes"
                        onChange={(e) => setHasHealthIssues(e.target.value === 'yes')}
                      /> Áno
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="has_health_issues"
                        value="no"
                        defaultChecked
                        onChange={(e) => setHasHealthIssues(e.target.value === 'yes')}
                      /> Nie
                    </label>
                  </td>
                </tr>

                {hasHealthIssues && (
                  <>
                    <tr>
                      <td style={{ padding: 6 }}>Zdravotné obmedzenia / alergie</td>
                      <td style={{ padding: 6 }}><input name="health_notes" placeholder="Zdravotné obmedzenia / alergie" required style={{ width: '100%' }} /></td>
                    </tr>
                    <tr>
                      <td style={{ padding: 6 }}></td>
                      <td style={{ padding: 6 }}><div style={{ color: '#a00', fontWeight: 600 }}>Poznámka: Môže byť vyžiadané lekárske potvrdenie k uvedeným obmedzeniam.</div></td>
                    </tr>
                  </>
                )}

                <tr>
                  <td style={{ padding: 6 }}>Súhlas so spracovaním osobných údajov (GDPR)</td>
                  <td style={{ padding: 6 }}><label><input type="checkbox" name="consent_gdpr" value="1" required /> Súhlasím so spracovaním osobných údajov</label></td>
                </tr>

                <tr>
                  <td style={{ padding: 6 }}>PIN</td>
                  <td style={{ padding: 6 }}>
                    <input name="pin" type="password" placeholder="PIN (4-6 číslic)" pattern="\d{4,6}" required title="PIN musí obsahovať 4 až 6 číslic" style={{ width: '100%' }} onBlur={(e) => handleFieldBlur('pin', e.target.value)} />
                    {errors.pin && <div style={{ color: 'red', fontSize: 12 }}>{errors.pin}</div>}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: 6 }}>Použitie PIN kódu</td>
                  <td style={{ padding: 6, color: '#333' }}>
                    <div>Tento PIN bude zároveň PIN kódom pre otváranie výplatných pások zasielaných elektronicky.</div>
                    <div style={{ marginTop: 6, fontSize: 13, color: '#666' }}>Súbory (doklady) nahrávajte až po úspešnej registrácii v sekcii dokumentov.</div>
                  </td>
                </tr>


                <tr>
                  <td style={{ padding: 6 }}>Poznámky</td>
                  <td style={{ padding: 6 }}><textarea name="notes" placeholder="Poznámky" style={{ width: '100%' }} /></td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
              <button type="submit" className="button-primary" disabled={saving}>
                {saving ? 'Ukladám...' : 'Pridať zamestnanca (bez emailu)'}
              </button>
              <button type="button" onClick={() => setShowNewEmployeeForm(false)}>Zrušiť</button>
            </div>
          </form>
        </div>
      )}
      {isAdmin ? (
        <>
          <div style={{ ...ui.card, marginTop: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0 }}>Všetci zamestnanci</h3>
              <span style={ui.badge}>{employees.length} záznamov</span>
            </div>
            <div style={{ ...ui.tableWrap, marginTop: 12 }}>
              {/* Filters */}
              <div style={{ padding: 12, display: 'flex', gap: 12, alignItems: 'center', borderBottom: '1px solid #e5e7eb' }}>
                <div>
                  <label style={{ fontSize: 13, color: '#334155' }}>Filter:</label>{' '}
                  <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="all">Všetko</option>
                    <option value="only_issues">Len s chýbajúcimi povinnosťami</option>
                    <option value="missing_sp">Chýba SP</option>
                    <option value="missing_zp">Chýba ZP</option>
                    <option value="missing_school">Chýba potvrdenie školy</option>
                    <option value="missing_invalidity">Chýba potvrdenie invalidity</option>
                    <option value="missing_any">Chýba niečo</option>
                    <option value="overdue_sp">Po termíne SP</option>
                    <option value="overdue_zp">Po termíne ZP</option>
                    <option value="only_brigade">Len brigádnici</option>
                    <option value="only_pensioner">Len dôchodcovia</option>
                    <option value="only_invalid">Len invalidi</option>
                  </select>
                </div>
                <div style={{ fontSize: 12, color: '#64748b' }}>
                  Legenda zvýraznení:
                  <span
                    onClick={() => setStatusFilter(statusFilter === 'missing_any' ? 'all' : 'missing_any')}
                    style={{
                      background: '#fee2e2',
                      border: '1px solid #fecaca',
                      padding: '2px 6px',
                      borderRadius: 6,
                      cursor: 'pointer',
                      boxShadow: statusFilter === 'missing_any' ? '0 0 0 2px #ef4444' : 'none'
                    }}
                  >
                    chýba povinnosť
                  </span>
                  {' '}
                  <span
                    onClick={() => setStatusFilter(statusFilter === 'overdue_any' ? 'all' : 'overdue_any')}
                    style={{
                      background: '#ffedd5',
                      border: '1px solid #fed7aa',
                      padding: '2px 6px',
                      borderRadius: 6,
                      marginLeft: 6,
                      cursor: 'pointer',
                      boxShadow: statusFilter === 'overdue_any' ? '0 0 0 2px #f97316' : 'none'
                    }}
                  >
                    po termíne
                  </span>
                </div>
              </div>
              <table style={ui.table}>
                <thead>
                  <tr>
                    <th style={ui.th}>osobné číslo</th>
                    <th style={ui.th}>meno</th>
                    <th style={ui.th}>rodné číslo</th>
                    <th style={ui.th}>dátum narodenia</th>
                    <th style={ui.th}>miesto narodenia</th>
                    <th style={ui.th}>adresa</th>
                    <th style={ui.th}>štátna príslušnosť</th>
                    <th style={ui.th}>rodinný stav</th>
                    <th style={ui.th}>telefón</th>
                    <th style={ui.th}>email</th>
                    <th style={ui.th}>číslo OP</th>
                    <th style={ui.th}>zdravotná poisťovňa</th>
                    <th style={ui.th}>banka / IBAN</th>
                    <th style={ui.th}>typ zmluvy</th>
                    <th style={ui.th}>pozícia</th>
                    <th style={ui.th}>dátum nástupu</th>
                    <th style={ui.th}>mzda brutto (€)</th>
                    <th style={ui.th}>počet detí</th>
                    <th style={ui.th}>pracovný pomer</th>
                    <th style={ui.th}>dotazník</th>
                    <th style={ui.th}>socpoist začiatok</th>
                    <th style={ui.th}>socpoist koniec</th>
                    <th style={ui.th}>zmluva začiatok</th>
                    <th style={ui.th}>zmluva koniec</th>
                    <th style={ui.th}>skúšobná doba</th>
                    <th style={ui.th}>úväzok / výsledok</th>
                    <th style={ui.th}>školenie dokument</th>
                    <th style={ui.th}>potvrdenie o návšteve školy</th>
                    <th style={ui.th}>prihlásenie ZP</th>
                    <th style={ui.th}>odhlásenie ZP</th>
                    <th style={ui.th}>prihlásenie SP</th>
                    <th style={ui.th}>odhlásenie SP</th>
                    <th style={ui.th}>potvrdenie o zdaniteľnej mzde</th>
                    <th style={ui.th}>ročné zúčtovanie dane</th>
                    <th style={ui.th}>ELDP</th>
                    <th style={ui.th}>vyhlásenie k dani</th>
                    <th style={ui.th}>vyhlásenie o odpočítateľnej položke SP (dôchodca a študent)</th>
                    <th style={ui.th}>vybavené komplet</th>
                    <th style={{ ...ui.th, textAlign: 'right' }}>Akcie</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.filter(emp => {
                    const q = search.trim().toLowerCase();
                    if (!q) return true;
                    const name = (emp.firstName ? `${emp.firstName} ${emp.lastName || ''}` : (emp.meno || '')).toLowerCase();
                    return name.includes(q) || String(emp.pin).includes(q);
                  }).filter(emp => {
                    // status filters
                    const yn = (v) => (v === '1' || v === 1 || v === true || String(v).toLowerCase() === 'yes');
                    const isBrigade = String(emp.contractType || '').toLowerCase().includes('brig');
                    const isPensioner = yn(emp.is_pensioner);
                    const isInvalid = yn(emp.is_invalid_pensioner);
                    const obl = emp.obligations || {};
                    const spDone = !!(obl.sp?.done || obl.sp?.date);
                    const zpApplicable = !isBrigade;
                    const zpDone = zpApplicable ? !!(obl.zp?.done || obl.zp?.date) : true;
                    const schoolDone = isBrigade ? !!(obl.school_confirm?.done || obl.school_confirm?.date) : true;
                    const invalidDocNeeded = isInvalid;
                    const invalidDocDone = invalidDocNeeded ? !!(obl.invalidity_confirm?.done || obl.invalidity_confirm?.date) : true;
                    const startDate = emp.startDate || emp.nastup || emp.start_date;
                    const dayMs = 24 * 60 * 60 * 1000;
                    const overdueSp = startDate ? (!spDone && (Date.now() - Date.parse(startDate) > dayMs)) : false;
                    const overdueZp = zpApplicable && startDate ? (!zpDone && (Date.now() - Date.parse(startDate) > dayMs)) : false;

                    switch (statusFilter) {
                      case 'only_issues':
                        return !(spDone && zpDone && invalidDocDone);
                      case 'missing_sp':
                        return !spDone;
                      case 'missing_zp':
                        return zpApplicable && !zpDone;
                      case 'missing_school':
                        return false;
                      case 'missing_invalidity':
                        return invalidDocNeeded && !invalidDocDone;
                      case 'missing_any':
                        return (!spDone || !zpDone || !invalidDocDone);
                      case 'overdue_sp':
                        return overdueSp;
                      case 'overdue_zp':
                        return overdueZp;
                      case 'overdue_any':
                        return overdueSp || overdueZp;
                      case 'only_brigade':
                        return isBrigade;
                      case 'only_pensioner':
                        return isPensioner;
                      case 'only_invalid':
                        return isInvalid;
                      default:
                        return true;
                    }
                  }).map((emp, idx) => {
                    const yn = (v) => (v === '1' || v === 1 || v === true || String(v).toLowerCase() === 'yes');
                    const isBrigade = String(emp.contractType || '').toLowerCase().includes('brig');
                    const obl = emp.obligations || {};

                    // Helper: format date
                    const fmt = (d) => {
                      try { return d ? new Date(d).toLocaleDateString('sk-SK') : ''; } catch { return ''; }
                    };

                    // Helper: render cell with color coding - RED only if not done AND required
                    const cell = (value, isOk, isRequired) => {
                      if (value === '' || value == null) return { text: '', bg: '#fff', color: '#000' };
                      const text = String(value);
                      if (isOk === true) return { text: text === 'true' || text === '1' ? 'ok' : text, bg: '#d4edda', color: '#155724' };
                      // RED only if not done AND required
                      if (isOk === false && isRequired === true) return { text: text === 'false' || text === '0' ? 'nie' : text, bg: '#f8d7da', color: '#721c24' };
                      // If not done but NOT required, show neutral
                      if (isOk === false) return { text: text === 'false' || text === '0' ? 'nie' : text, bg: '#fff', color: '#666' };
                      return { text, bg: '#fff', color: '#000' };
                    };

                    const startDate = emp.startDate || emp.nastup || emp.start_date || '';
                    const endDate = obl.work_end?.date || '';

                    // Check if each obligation is done AND if it's required
                    const spDone = !!(obl.sp?.done || obl.sp?.date);
                    const spRequired = !!(obl.sp?.required);

                    const zpApplicable = !isBrigade;
                    const zpDone = zpApplicable ? !!(obl.zp?.done || obl.zp?.date) : true;
                    const zpRequired = !!(obl.zp?.required);

                    const schoolDone = isBrigade ? !!(obl.school_confirm?.done || obl.school_confirm?.date) : true;
                    const schoolRequired = !!(obl.school_confirm?.required);

                    const bozpDone = !!(obl.bozp?.done || obl.bozp?.date);
                    const bozpRequired = !!(obl.bozp?.required);

                    const taxDone = !!(obl.tax?.done || obl.tax?.date);
                    const noWageConfirmDone = !!(obl.no_wage_confirm?.done || obl.no_wage_confirm?.date);
                    const noWageConfirmRequired = !!(obl.no_wage_confirm?.required);

                    const annualTaxDone = !!(obl.annual_tax?.done || obl.annual_tax?.date);
                    const annualTaxRequired = !!(obl.annual_tax?.required);
                    const eldpDone = !!(obl.eldp?.done || obl.eldp?.date);
                    const eldpRequired = !!(obl.eldp?.required);

                    const taxDeclarationDone = yn(emp.tax_vyhlasenie);

                    const socpoistDeclarationDone = !!(obl.socpoist_declaration?.done || obl.socpoist_declaration?.date);
                    const socpoistDeclarationRequired = !!(obl.socpoist_declaration?.required);

                    const paidCompleteDone = !!(obl.paid_complete?.done || obl.paid_complete?.date);
                    const paidCompleteRequired = !!(obl.paid_complete?.required);

                    const questionnaireDone = !!(obl.questionnaire?.done || obl.questionnaire?.date);
                    const questionnaireRequired = !!(obl.questionnaire?.required);

                    const trialPeriod = emp.has_trial_period ? (emp.trial_period_months ? `${emp.trial_period_months} mes.` : 'áno') : '';
                    const workload = emp.dohodnuty_uvazok || emp.part_time_hours_per_day || '';

                    // Row background - red only if something REQUIRED is missing
                    // Note: removed PZS checks (pzsDone/pzsRequired) as these fields were removed
                    const hasMissingRequired = (!spDone && spRequired) || (!zpDone && zpRequired) || (!bozpDone && bozpRequired);
                    const rowBg = hasMissingRequired ? '#fff1f2' : (idx % 2 ? '#f8f9fa' : '#fff');

                    return (
                      <tr key={emp.pin || emp.id} style={{ background: rowBg, cursor: 'pointer' }} onClick={() => openAdminEdit(emp)}>
                        <td style={ui.td}>{emp.osobne_cislo || emp.pin}</td>
                        <td style={{ ...ui.td, fontWeight: 600 }}>
                          {emp.firstName ? `${emp.firstName} ${emp.lastName || ''}` : emp.meno}
                        </td>
                        <td style={ui.td}>{emp.rodne_cislo || '-'}</td>
                        <td style={ui.td}>{fmt(emp.birthDate)}</td>
                        <td style={ui.td}>{emp.birth_place || '-'}</td>
                        <td style={ui.td}>{[emp.street_name, emp.cislo_domu, emp.city, emp.zip].filter(Boolean).join(', ')}</td>
                        <td style={ui.td}>{emp.state_citizenship === 'other' ? emp.state_citizenship_other : emp.state_citizenship}</td>
                        <td style={ui.td}>{emp.marital_status || '-'}</td>
                        <td style={ui.td}>{emp.phone || '-'}</td>
                        <td style={ui.td}>{emp.email || '-'}</td>
                        <td style={ui.td}>{emp.id_card || '-'}</td>
                        <td style={ui.td}>{emp.insurance === 'other' ? emp.insurance_other : emp.insurance}</td>
                        <td style={ui.td}>{emp.bank_name ? `${emp.bank_name} / ${emp.bank_iban || ''}` : (emp.bank_iban || '-')}</td>
                        <td style={ui.td}>{emp.contractType || emp.pracovnyPomer || 'dovp'}</td>
                        <td style={ui.td}>{emp.position || '-'}</td>
                        <td style={ui.td}>{fmt(startDate)}</td>
                        <td style={ui.td}>{emp.wage_brutto ? `${emp.wage_brutto} €` : '-'}</td>
                        <td style={ui.td}>{emp.children_count || '0'}</td>
                        <td style={ui.td}>{emp.contractType || emp.pracovnyPomer || 'dovp'}</td>
                        <td style={{ ...ui.td, ...{ background: cell('', questionnaireDone, questionnaireRequired).bg, color: cell('', questionnaireDone, questionnaireRequired).color } }}>
                          {fmt(obl.questionnaire?.date) || (questionnaireDone ? 'ok' : '')}
                        </td>
                        <td style={ui.td}>{fmt(obl.sp?.date)}</td>
                        <td style={ui.td}>{fmt(obl.sp_end?.date)}</td>
                        <td style={ui.td}>{fmt(startDate)}</td>
                        <td style={ui.td}>{fmt(endDate)}</td>
                        <td style={ui.td}>{trialPeriod}</td>
                        <td style={ui.td}>{workload}</td>
                        <td style={{ ...ui.td, ...{ background: cell('', bozpDone, bozpRequired).bg, color: cell('', bozpDone, bozpRequired).color } }}>
                          {fmt(obl.bozp?.date) || (bozpDone ? 'ok' : 'nie')}
                        </td>
                        <td style={{ ...ui.td, background: '#fff' }}>
                          {isBrigade ? (fmt(obl.school_confirm?.date) || 'nie je potvrdené') : 'nie je potvrdené'}
                        </td>
                        <td style={{ ...ui.td, ...{ background: zpApplicable ? cell('', zpDone, zpRequired).bg : '#fff', color: zpApplicable ? cell('', zpDone, zpRequired).color : '#000' } }}>
                          {zpApplicable ? (fmt(obl.zp?.date) || (zpDone ? 'ok' : 'nie je potvrdené')) : 'nie je potvrdené'}
                        </td>
                        <td style={ui.td}>{fmt(obl.zp_end?.date) || 'nie je potvrdené'}</td>
                        <td style={{ ...ui.td, ...{ background: cell('', spDone, spRequired).bg, color: cell('', spDone, spRequired).color } }}>
                          {fmt(obl.sp?.date) || (spDone ? 'ok' : 'nie je potvrdené')}
                        </td>
                        <td style={ui.td}>{fmt(obl.sp_end?.date) || 'nie je potvrdené'}</td>
                        <td style={{ ...ui.td, ...{ background: cell('', noWageConfirmDone, noWageConfirmRequired).bg, color: cell('', noWageConfirmDone, noWageConfirmRequired).color } }}>
                          {fmt(obl.no_wage_confirm?.date) || (noWageConfirmDone ? 'ok' : 'nie je potvrdené')}
                        </td>
                        <td style={{ ...ui.td, ...{ background: cell('', annualTaxDone, annualTaxRequired).bg, color: cell('', annualTaxDone, annualTaxRequired).color } }}>
                          {fmt(obl.annual_tax?.date) || (annualTaxDone ? 'ok' : 'nie je potvrdené')}
                        </td>
                        <td style={{ ...ui.td, ...{ background: cell('', eldpDone, eldpRequired).bg, color: cell('', eldpDone, eldpRequired).color } }}>
                          {fmt(obl.eldp?.date) || (eldpDone ? 'ok' : 'nie')}
                        </td>
                        <td style={{ ...ui.td, ...{ background: cell('', taxDeclarationDone, false).bg, color: cell('', taxDeclarationDone, false).color } }}>
                          {taxDeclarationDone ? 'ok' : 'nie je potvrdené'}
                        </td>
                        <td style={{ ...ui.td, ...{ background: cell('', socpoistDeclarationDone, socpoistDeclarationRequired).bg, color: cell('', socpoistDeclarationDone, socpoistDeclarationRequired).color } }}>
                          {fmt(obl.socpoist_declaration?.date) || (socpoistDeclarationDone ? 'ok' : (obl.socpoist_declaration?.notes ? obl.socpoist_declaration?.notes : ''))}
                        </td>
                        <td style={{ ...ui.td, ...{ background: cell('', paidCompleteDone, paidCompleteRequired).bg, color: cell('', paidCompleteDone, paidCompleteRequired).color } }}>
                          {paidCompleteDone ? 'ok' : 'FALSE'}
                        </td>
                        <td style={{ ...ui.td, textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
                          <button style={{ ...ui.btnGhost }} onClick={() => loadDocuments(emp.pin)}>Dokumenty</button>
                          <button style={{ ...ui.btnGhost, marginLeft: 8 }} onClick={() => printEmployeeCard(emp)}>Tlačiť kartu</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {editingPin && (
            <div
              style={{ ...ui.card, marginTop: 20, outline: 'none' }}
              tabIndex={0}
              autoFocus
              onKeyDown={(e) => {
                // Ctrl+Enter saves and closes editor
                if (e.key === 'Enter' && e.ctrlKey && !editSaving) {
                  e.preventDefault();
                  handleAdminSaveEdit(true);
                }
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ marginTop: 0 }}>Úprava zamestnanca (PIN {editingPin})</h3>
                <div style={{ fontSize: 12, color: '#64748b' }}>Tip: Ctrl+Enter pre uloženie a zatvorenie</div>
              </div>

              {/* Citlivé údaje */}
              <div style={{ marginBottom: 16, padding: 12, border: '1px solid #fef3c7', borderRadius: 8, background: '#fffbeb' }}>
                <h4 style={{ margin: '0 0 12px 0', color: '#92400e' }}>⚠️ Citlivé údaje (šifrované)</h4>
                <div style={{ fontSize: 11, color: '#78350f', marginBottom: 12 }}>
                  Ak vidíte zašifrované hodnoty namiesto čitateľných dát, zadajte správne hodnoty nižšie a uložte.
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: '4px 8px', width: '200px', fontWeight: 600 }}>Rodné číslo:</td>
                      <td style={{ padding: '4px 8px' }}>
                        <input
                          type="text"
                          placeholder="napr. 123456/7890"
                          value={editData.rodne_cislo || ''}
                          onChange={(e) => { handleAdminEditChange('rodne_cislo', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4 }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px 8px', fontWeight: 600 }}>Miesto narodenia:</td>
                      <td style={{ padding: '4px 8px' }}>
                        <input
                          type="text"
                          placeholder="napr. Poprad"
                          value={editData.birth_place || ''}
                          onChange={(e) => { handleAdminEditChange('birth_place', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4 }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px 8px', fontWeight: 600 }}>Číslo OP:</td>
                      <td style={{ padding: '4px 8px' }}>
                        <input
                          type="text"
                          placeholder="napr. AA123456"
                          value={editData.id_card || ''}
                          onChange={(e) => { handleAdminEditChange('id_card', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4 }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px 8px', fontWeight: 600 }}>IBAN:</td>
                      <td style={{ padding: '4px 8px' }}>
                        <input
                          type="text"
                          placeholder="napr. SK1234567890"
                          value={editData.bank_iban || ''}
                          onChange={(e) => { handleAdminEditChange('bank_iban', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4 }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px 8px', fontWeight: 600 }}>Hrubá mzda (€):</td>
                      <td style={{ padding: '4px 8px' }}>
                        <input
                          type="number"
                          step="0.01"
                          placeholder="napr. 1200.00"
                          value={editData.wage_brutto || ''}
                          onChange={(e) => { handleAdminEditChange('wage_brutto', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4 }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px 8px', fontWeight: 600 }}>Poznámky k zdraviu:</td>
                      <td style={{ padding: '4px 8px' }}>
                        <textarea
                          placeholder="Zdravotné poznámky (nepovinné)"
                          value={editData.health_notes || ''}
                          onChange={(e) => { handleAdminEditChange('health_notes', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4, minHeight: 60, resize: 'vertical' }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px 8px', fontWeight: 600 }}>Predchádzajúci zamestnávateľ:</td>
                      <td style={{ padding: '4px 8px' }}>
                        <input
                          type="text"
                          placeholder="Predchádzajúci zamestnávateľ (nepovinné)"
                          value={editData.previous_employer || ''}
                          onChange={(e) => { handleAdminEditChange('previous_employer', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4 }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px 8px', fontWeight: 600 }}>Pracovné povolenie:</td>
                      <td style={{ padding: '4px 8px' }}>
                        <input
                          type="text"
                          placeholder="Číslo pracovného povolenia (nepovinné)"
                          value={editData.work_permit || ''}
                          onChange={(e) => { handleAdminEditChange('work_permit', e.target.value); }}
                          style={{ width: '100%', padding: 6, border: '1px solid #d97706', borderRadius: 4 }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Povinnosti a termíny */}
              <div style={{ marginBottom: 16, padding: 12, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fafafa' }}>
                <h4 style={{ margin: '0 0 8px 0' }}>Povinnosti a termíny</h4>
                {(() => {
                  const obligations = editData.obligations || {};
                  const yn = (v) => (v === '1' || v === 1 || v === true || String(v).toLowerCase() === 'yes');
                  const isBrigade = String(editData.contractType || '').toLowerCase().includes('brig');
                  const isPensioner = yn(editData.is_pensioner);
                  const isInvalid = yn(editData.is_invalid_pensioner);

                  const items = [
                    // Požadované poradie podľa zadania
                    { key: 'questionnaire', label: 'Dotazník vyplnený' },
                    { key: 'work_start', label: 'Vznik pracovného vzťahu (dátum nástupu)' },
                    { key: 'sp', label: 'Sociálna poisťovňa – prihlásenie (dátum prihlásenia)' },
                    // ZP prihlásenie len ak nie je brigáda
                    ...(isBrigade ? [] : [
                      { key: 'zp', label: 'Zdravotná poisťovňa – prihlásenie (dátum prihlásenia)' }
                    ]),
                    { key: 'bozp', label: 'Vyhlásenie k dani' },
                    { key: 'socpoist_declaration', label: 'Vyhlásenie o odpočítateľnej položke SP (dôchodca a študent)' },
                    // Potvrdenie o návšteve školy (len pre brigádu) - má byť pred zánikom pracovného vzťahu
                    ...(isBrigade ? [
                      { key: 'school_confirm', label: 'Potvrdenie o návšteve školy' }
                    ] : []),
                    { key: 'work_end', label: 'Zánik pracovného vzťahu (dátum ukončenia)' },
                    { key: 'sp_end', label: 'Sociálna poisťovňa – odhlásenie (dátum odhlásenia)' },
                    // ZP odhlásenie len ak nie je brigáda
                    ...(isBrigade ? [] : [
                      { key: 'zp_end', label: 'Zdravotná poisťovňa – odhlásenie (dátum odhlásenia)' }
                    ]),
                    { key: 'no_wage_confirm', label: 'Potvrdenie o zdaniteľnej mzde' },
                    { key: 'annual_tax', label: 'Ročné zúčtovanie dane' },
                    { key: 'eldp', label: 'ELDP' },
                    // Vybavené komplet ide úplne naspodok
                    { key: 'paid_complete', label: 'Vybavené komplet' },
                    // Invalid: potvrdenie o invalidite (na konci sekcie, ak relevantné)
                    ...(isInvalid ? [
                      { key: 'invalidity_confirm', label: 'Potvrdenie o invalidite' }
                    ] : [])
                  ];

                  const getObl = (k) => (obligations[k] || {});
                  const updateObl = (k, field, value) => {
                    setEditData(prev => ({
                      ...prev,
                      obligations: {
                        ...(prev.obligations || {}),
                        [k]: { ...(prev.obligations?.[k] || {}), [field]: value }
                      }
                    }));
                    setDirty(true);
                  };

                  const today = () => new Date().toISOString().slice(0, 10);

                  return (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'left', padding: 6 }}>Povinnosť</th>
                          <th style={{ textAlign: 'center', padding: 6, width: 80 }}>Povinné</th>
                          <th style={{ textAlign: 'center', padding: 6, width: 100 }}>Nepovinné</th>
                          <th style={{ textAlign: 'left', padding: 6, width: 120 }}>Splnené</th>
                          <th style={{ textAlign: 'left', padding: 6, width: 160 }}>Dátum</th>
                          <th style={{ textAlign: 'left', padding: 6 }}>Poznámka</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map(item => {
                          const o = getObl(item.key);
                          const done = !!(o.done === true || o.done === '1' || o.done === 1 || String(o.done).toLowerCase() === 'true');
                          const required = !!(o.required === true || o.required === '1' || o.required === 1 || String(o.required).toLowerCase() === 'true');
                          const optional = !!(o.optional === true || o.optional === '1' || o.optional === 1 || String(o.optional).toLowerCase() === 'true');
                          // Row background: green when done, red when required but not done, otherwise transparent
                          const rowBg = done ? '#d6f5d6' : (required ? '#ffdada' : 'transparent');
                          return (
                            <tr key={item.key} style={{ background: rowBg }}>
                              <td style={{ padding: 6 }}>{item.label}</td>
                              <td style={{ padding: 6, textAlign: 'center' }}>
                                <input
                                  type="checkbox"
                                  checked={required}
                                  onChange={(e) => {
                                    updateObl(item.key, 'required', e.target.checked);
                                    if (e.target.checked) updateObl(item.key, 'optional', false);
                                  }}
                                />
                              </td>
                              <td style={{ padding: 6, textAlign: 'center' }}>
                                <input
                                  type="checkbox"
                                  checked={optional}
                                  onChange={(e) => {
                                    updateObl(item.key, 'optional', e.target.checked);
                                    if (e.target.checked) updateObl(item.key, 'required', false);
                                  }}
                                />
                              </td>
                              <td style={{ padding: 6 }}>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={done}
                                    onChange={(e) => {
                                      const val = e.target.checked;
                                      updateObl(item.key, 'done', val);
                                      if (val && !o.date) updateObl(item.key, 'date', today());
                                    }}
                                  />{' '}Hotovo
                                </label>
                              </td>
                              <td style={{ padding: 6 }}>
                                <input
                                  type="date"
                                  value={o.date || ''}
                                  onChange={(e) => updateObl(item.key, 'date', e.target.value)}
                                  style={{ width: '100%' }}
                                />
                              </td>
                              <td style={{ padding: 6 }}>
                                <input
                                  type="text"
                                  placeholder="Poznámka / číslo podania"
                                  value={o.notes || ''}
                                  onChange={(e) => updateObl(item.key, 'notes', e.target.value)}
                                  style={{ width: '100%' }}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  );
                })()}
              </div>

              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                  {Object.entries(editData).filter(([k]) => !['documents', 'filled_by', 'filled_on', 'id', 'created_at', 'updated_at'].includes(k)).map(([k, v]) => {
                    if (k === 'pin') return null;
                    if (k === 'obligations') return null; // rendered above as dedicated section

                    // Slovak field labels mapping
                    const fieldLabels = {
                      email: 'E-mail',
                      titleBefore: 'Titul pred menom',
                      firstName: 'Krstné meno',
                      lastName: 'Priezvisko',
                      titleAfter: 'Titul za menom',
                      birth_lastname: 'Rodné priezvisko',
                      birthDate: 'Dátum narodenia',
                      rodne_cislo: 'Rodné číslo',
                      birth_place: 'Miesto narodenia',
                      nationality: 'Národnosť',
                      state_citizenship: 'Štátna príslušnosť',
                      state_citizenship_other: 'Iná štátna príslušnosť',
                      id_card: 'Číslo občianskeho preukazu',
                      street_name: 'Ulica',
                      cislo_domu: 'Číslo domu',
                      city: 'Mesto',
                      zip: 'PSČ',
                      marital_status: 'Rodinný stav',
                      phone: 'Telefón',
                      insurance: 'Zdravotná poisťovňa',
                      insurance_other: 'Iná poisťovňa',
                      bank_name: 'Banka',
                      bank_iban: 'IBAN',
                      is_student: 'Som študent',
                      is_pensioner: 'Som poberateľom dôchodku',
                      is_invalid_pensioner: 'Som poberateľom invalidného dôchodku',
                      is_registered_unemployment: 'Som evidovaný na úrade práce',
                      position: 'Dohodnutá pracovná pozícia',
                      osobne_cislo: 'Osobné číslo zamestnanca',
                      has_trial_period: 'Skúšobná doba',
                      trial_period_months: 'Dĺžka skúšobnej doby (mesiace)',
                      previous_employer: 'Predchádzajúci zamestnávateľ',
                      work_permit: 'Pracovné povolenie / vízum',
                      company: 'Spoločnosť',
                      declaration_truth: 'Vyhlásenie o pravdivosti',
                      contractType: 'Typ pracovného pomeru',
                      part_time_hours_per_day: 'Skrátený úväzok (hod./deň)',
                      startDate: 'Možný dátum nástupu',
                      dohodnuty_uvazok: 'Dohodnutý úväzok (hod./týždeň)',
                      wage_type: 'Typ mzdy',
                      wage_brutto: 'Mzda brutto (€)',
                      contract_duration_type: 'Doba trvania zmluvy',
                      tax_vyhlasenie: 'Úľava na dani',
                      children_count: 'Počet detí',
                      tax_bonus: 'Daňový bonus',
                      has_health_issues: 'Zdravotné obmedzenia',
                      health_notes: 'Popis zdravotných obmedzení',
                      consent_gdpr: 'Súhlas GDPR',
                      notes: 'Poznámky'
                    };

                    const label = fieldLabels[k] || k.replace(/_/g, ' ');
                    const lower = k.toLowerCase();
                    const isTextarea = ['notes', 'health_notes'].includes(k);
                    const isNumber = ['children_count', 'wage_brutto', 'part_time_hours_per_day', 'trial_period_months'].includes(k);
                    const isDate = lower.includes('date');
                    const booleanFields = ['is_student', 'is_pensioner', 'is_invalid_pensioner', 'is_registered_unemployment', 'has_trial_period', 'declaration_truth', 'consent_gdpr', 'tax_vyhlasenie', 'tax_bonus'];
                    const isBool = booleanFields.includes(k);
                    const asYesNo = (val) => (val === '1' || val === 1 || val === true || String(val).toLowerCase() === 'yes') ? 'yes' : (String(val).toLowerCase() === 'no' || val === '0' || val === 0 ? 'no' : '');
                    const currentYN = asYesNo(v);
                    return (
                      <tr key={k}>
                        <td style={{ padding: 8, width: '30%', fontWeight: 600, background: '#f8fafc' }}>{label}</td>
                        <td style={{ padding: 8 }}>
                          {k === 'contractType' ? (
                            <select value={editData.contractType || ''} onChange={e => handleAdminEditChange('contractType', e.target.value)} style={{ width: '100%' }}>
                              <option value="">-- vyberte --</option>
                              <option value="pracovny_pomer">pracovný pomer</option>
                              <option value="dohoda_vykon">dohoda o vykonaní práce</option>
                              <option value="dohoda_prac">dohoda o pracovnej činnosti</option>
                              <option value="brigada">dohoda o brigádnickej práci študentov</option>
                            </select>
                          ) : k === 'insurance' ? (
                            <select value={editData.insurance || ''} onChange={e => handleAdminEditChange('insurance', e.target.value)} style={{ width: '100%' }}>
                              <option value="">-- vyberte --</option>
                              <option value="vszP">Všeobecná zdravotná poisťovňa</option>
                              <option value="dovera">Dôvera</option>
                              <option value="union">Union</option>
                              <option value="other">Iná</option>
                            </select>
                          ) : isBool ? (
                            <select value={currentYN} onChange={e => handleAdminEditChange(k, e.target.value)} style={{ width: '100%' }}>
                              <option value="">--</option>
                              <option value="yes">Áno</option>
                              <option value="no">Nie</option>
                            </select>
                          ) : isTextarea ? (
                            <textarea value={editData[k] || ''} onChange={e => handleAdminEditChange(k, e.target.value)} style={{ width: '100%', minHeight: 80, padding: 8, borderRadius: 8, border: '1px solid #e5e7eb' }} />
                          ) : (
                            <input
                              type={isDate ? 'date' : (isNumber ? 'number' : 'text')}
                              value={editData[k] == null ? '' : editData[k]}
                              onChange={e => handleAdminEditChange(k, e.target.value)}
                              style={{ width: '100%', padding: 8, borderRadius: 8, border: '1px solid #e5e7eb' }}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div style={{ marginTop: 12 }}>
                <button style={ui.btn} onClick={handleAdminSaveEdit} disabled={editSaving}>{editSaving ? 'Ukladám…' : 'Uložiť zmeny'}</button>
                <button style={{ ...ui.btnGhost, marginLeft: 8 }} onClick={handleCloseEditor}>Zavrieť</button>
                {editMessage && <span style={{ marginLeft: 12, color: editMessage.includes('uložené') ? '#16a34a' : '#dc2626' }}>{editMessage}</span>}
              </div>
            </div>
          )}

          {docsPin && (
            <div style={{ ...ui.card, marginTop: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0 }}>Dokumenty (PIN {docsPin})</h3>
                <button style={ui.btnGhost} onClick={() => setDocsPin(null)}>Zavrieť</button>
              </div>
              <div style={{ marginTop: 10 }}>
                {docsLoading ? (
                  <div>Načítavam…</div>
                ) : (
                  documents.length ? (
                    <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                      {documents.map(doc => (
                        <li key={doc.filename} style={{ padding: '8px 0', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <div style={{ fontWeight: 600 }}>{doc.originalName || doc.filename}</div>
                            <div style={{ fontSize: 12, color: '#64748b' }}>{new Date(doc.uploadedAt).toLocaleString()}{doc.size ? ` • ${(doc.size / 1024).toFixed(1)} kB` : ''}</div>
                          </div>
                          <div style={{ display: 'flex', gap: 8 }}>
                            <a href={doc.url} target="_blank" rel="noreferrer" style={ui.btnGhost}>Stiahnuť</a>
                            <button
                              style={{ ...ui.btnGhost, color: '#dc2626', borderColor: '#dc2626' }}
                              onClick={async () => {
                                if (window.confirm(`Naozaj chcete zmazať dokument "${doc.originalName || doc.filename}"?`)) {
                                  try {
                                    const res = await fetch(ADMIN_PORTAL + `?action=delete_document&pin=${encodeURIComponent(docsPin)}&file=${encodeURIComponent(doc.filename)}`, {
                                      method: 'DELETE',
                                      credentials: 'include'
                                    });
                                    if (!res.ok) {
                                      const errData = await res.json().catch(() => ({}));
                                      throw new Error(errData.error || 'Chyba pri mazaní');
                                    }
                                    await loadDocuments(docsPin);
                                  } catch (err) {
                                    alert('Chyba pri mazaní dokumentu: ' + err.message);
                                  }
                                }
                              }}
                            >
                              Zmazať
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div>Žiadne dokumenty</div>
                  )
                )}
              </div>
              <div style={{ marginTop: 12 }}>
                <input type="file" id={`file-${docsPin}`} />
                <button style={{ ...ui.btn, marginLeft: 8 }} onClick={async () => { await handleUpload(docsPin); await loadDocuments(docsPin); }}>Nahrať dokument</button>
              </div>
            </div>
          )}
        </>
      ) : (
          <div style={{ maxWidth: 900, margin: '0 auto' }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, paddingBottom: 16, borderBottom: '2px solid #3b82f6' }}>
                <h3 style={{ margin: 0, color: '#1e40af', fontSize: 24 }}>👤 Moje údaje</h3>
                <button onClick={handleLogout} style={{ padding: '8px 16px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>Odhlásiť</button>
              </div>
          {currentEmployee ? (
                <>
                  <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: 8, overflow: 'hidden' }}>
                    <tbody>
                      {Object.entries(currentEmployee).map(([k, v]) => {
                        // skip internal metadata and complex objects
                        if (k === 'documents') return null;
                        if (k === 'obligations') return null; // Will show separately below
                        if (k === 'filled_by' || k === 'filled_on') return null;

                        // Slovak field labels mapping
                        const fieldLabels = {
                          pin: 'PIN',
                          email: 'E-mail',
                          titleBefore: 'Titul pred menom',
                          firstName: 'Krstné meno',
                          lastName: 'Priezvisko',
                          titleAfter: 'Titul za menom',
                          birth_lastname: 'Rodné priezvisko',
                          birthDate: 'Dátum narodenia',
                          rodne_cislo: 'Rodné číslo',
                          birth_place: 'Miesto narodenia',
                          nationality: 'Národnosť',
                          state_citizenship: 'Štátna príslušnosť',
                          state_citizenship_other: 'Iná štátna príslušnosť',
                          id_card: 'Číslo občianskeho preukazu',
                          street_name: 'Ulica',
                          cislo_domu: 'Číslo domu',
                          city: 'Mesto',
                          zip: 'PSČ',
                          marital_status: 'Rodinný stav',
                          phone: 'Telefón',
                          insurance: 'Zdravotná poisťovňa',
                          insurance_other: 'Iná poisťovňa',
                          bank_name: 'Banka',
                          bank_iban: 'IBAN',
                          is_student: 'Som študent',
                          is_pensioner: 'Som poberateľom dôchodku',
                          is_invalid_pensioner: 'Som poberateľom invalidného dôchodku',
                          is_registered_unemployment: 'Som evidovaný na úrade práce',
                          position: 'Dohodnutá pracovná pozícia',
                          osobne_cislo: 'Osobné číslo zamestnanca',
                          has_trial_period: 'Skúšobná doba',
                          trial_period_months: 'Dĺžka skúšobnej doby (mesiace)',
                          previous_employer: 'Predchádzajúci zamestnávateľ',
                          work_permit: 'Pracovné povolenie / vízum',
                          company: 'Spoločnosť',
                          declaration_truth: 'Vyhlásenie o pravdivosti',
                          contractType: 'Typ pracovného pomeru',
                          part_time_hours_per_day: 'Skrátený úväzok (hod./deň)',
                          startDate: 'Možný dátum nástupu',
                          dohodnuty_uvazok: 'Dohodnutý úväzok (hod./týždeň)',
                          wage_type: 'Typ mzdy',
                          wage_brutto: 'Mzda brutto (€)',
                          contract_duration_type: 'Doba trvania zmluvy',
                          tax_vyhlasenie: 'Úľava na dani',
                          children_count: 'Počet detí',
                          tax_bonus: 'Daňový bonus',
                          has_health_issues: 'Zdravotné obmedzenia',
                          health_notes: 'Popis zdravotných obmedzení',
                          consent_gdpr: 'Súhlas GDPR',
                          notes: 'Poznámky'
                        };

                        const label = fieldLabels[k] || k.replace(/_/g, ' ');
                        let value = v;
                        if (v === '1' || v === 1) value = 'Áno';
                        if (v === '0' || v === 0) value = 'Nie';
                        if (typeof v === 'object') return null; // Skip other complex objects
                        return (
                          <tr key={k} style={{ borderBottom: '1px solid #e5e7eb' }}>
                            <td style={{ padding: 12, width: '40%', verticalAlign: 'top', fontWeight: 600, background: '#f8fafc', color: '#1e40af' }}>{label}</td>
                            <td style={{ padding: 12, color: '#334155' }}>{value}</td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
                </>
          ) : (
                  <div style={{ padding: 20, textAlign: 'center', color: '#64748b' }}>Žiadne údaje</div>
          )}
            </div>

            <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
              <h4 style={{ margin: '0 0 16px 0', color: '#1e40af', fontSize: 18, borderBottom: '2px solid #3b82f6', paddingBottom: 8 }}>📎 Nahrať dokumenty</h4>
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <input type="file" id="my-upload-file" style={{ flex: 1, padding: '8px 12px', border: '2px solid #e5e7eb', borderRadius: 6 }} />
                <button
                  onClick={() => handleUpload(currentEmployee?.pin || pinInput)}
                  style={{ padding: '10px 20px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}
                >
                  Nahrať dokument
                </button>
              </div>
              {uploading && <div style={{ marginTop: 12, color: '#3b82f6', fontWeight: 600 }}>⏳ Nahrávam...</div>}
              {uploadError && <div style={{ marginTop: 12, padding: 12, background: '#fee2e2', color: '#dc2626', borderRadius: 6, border: '1px solid #fca5a5' }}>{uploadError}</div>}
            </div>
          </div>
      )}
    </div>
  );
}

// Helper functions (inside module scope but using window-level fetch) — they reference server endpoints
async function loadEmployeeDetail(pin) {
  try {
    const res = await fetch(`/php/employee_portal.php?action=login&pin=${encodeURIComponent(pin)}`);
    if (!res.ok) throw new Error('Chyba pri načítaní detailu');
    const text = await res.text();
    const emp = JSON.parse(text || '{}');
    // Detail loaded - you can add UI here if needed
  } catch (e) {
    alert('Chyba: ' + e.message);
  }
}

async function handleUpload(pin) {
  // find file input
  const fileInput = document.getElementById(`file-${pin}`) || document.getElementById('my-upload-file');
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
    alert('Vyberte súbor na nahratie');
    return;
  }
  const file = fileInput.files[0];
  const form = new FormData();
  form.append('pin', pin);
  form.append('file', file);
  try {
    // basic UI feedback
    const res = await fetch('/php/upload_document.php', {
      method: 'POST',
      body: form
    });
    const text = await res.text();
    let data = null;
    try { data = JSON.parse(text); } catch (e) { /* tolerate non-JSON if status=200 */ }
    if (!res.ok) throw new Error((data && data.error) || (text && text.slice(0, 200)) || 'Upload zlyhal');
    // Treat HTTP 200 as success even if response wasn't valid JSON (some hosts inject whitespace/notes)
    alert('Súbor nahratý');
  } catch (e) {
    alert('Chyba pri upload: ' + (e.message || e));
  }
}



